/**
 * Offline bootstrap for OverCut Trayectoria.
 *
 * GENERATED FILE - do not edit by hand. Rebuild with:
 *   python src/main/resources/scripts/generate_trayectoria_fallback.py
 *
 * One season per decade, with the real calendar, line-ups and constructors'
 * championship of each, so the game stays playable when the backend is not
 * reachable. The full history lives behind /api/overcutTrayectoria/bootstrap.
 */

export const fallbackBootstrap = {
  "dataSource": "fallback (generate_trayectoria_fallback.py)",
  "currentYear": 2024,
  "seasonYears": [
    1955,
    1965,
    1976,
    1988,
    1998,
    2008,
    2016,
    2024
  ],
  "decades": [
    {
      "key": "1950s",
      "label": "1950s",
      "from": 1950,
      "to": 1959
    },
    {
      "key": "1960s",
      "label": "1960s",
      "from": 1960,
      "to": 1969
    },
    {
      "key": "1970s",
      "label": "1970s",
      "from": 1970,
      "to": 1979
    },
    {
      "key": "1980s",
      "label": "1980s",
      "from": 1980,
      "to": 1989
    },
    {
      "key": "1990s",
      "label": "1990s",
      "from": 1990,
      "to": 1999
    },
    {
      "key": "2000s",
      "label": "2000s",
      "from": 2000,
      "to": 2009
    },
    {
      "key": "2010s",
      "label": "2010s",
      "from": 2010,
      "to": 2019
    },
    {
      "key": "2020s",
      "label": "2020s",
      "from": 2020,
      "to": 2029
    }
  ],
  "racesByYear": {
    "1955": [
      {
        "round": 1,
        "name": "Argentine Grand Prix",
        "country": "ar"
      },
      {
        "round": 2,
        "name": "Monaco Grand Prix",
        "country": "mc"
      },
      {
        "round": 3,
        "name": "Indianapolis 500",
        "country": "us"
      },
      {
        "round": 4,
        "name": "Belgian Grand Prix",
        "country": "be"
      },
      {
        "round": 5,
        "name": "Dutch Grand Prix",
        "country": "nl"
      },
      {
        "round": 6,
        "name": "British Grand Prix",
        "country": "gb"
      },
      {
        "round": 7,
        "name": "Italian Grand Prix",
        "country": "it"
      }
    ],
    "1965": [
      {
        "round": 1,
        "name": "South African Grand Prix",
        "country": "za"
      },
      {
        "round": 2,
        "name": "Monaco Grand Prix",
        "country": "mc"
      },
      {
        "round": 3,
        "name": "Belgian Grand Prix",
        "country": "be"
      },
      {
        "round": 4,
        "name": "French Grand Prix",
        "country": "fr"
      },
      {
        "round": 5,
        "name": "British Grand Prix",
        "country": "gb"
      },
      {
        "round": 6,
        "name": "Dutch Grand Prix",
        "country": "nl"
      },
      {
        "round": 7,
        "name": "German Grand Prix",
        "country": "de"
      },
      {
        "round": 8,
        "name": "Italian Grand Prix",
        "country": "it"
      },
      {
        "round": 9,
        "name": "United States Grand Prix",
        "country": "us"
      },
      {
        "round": 10,
        "name": "Mexican Grand Prix",
        "country": "mx"
      }
    ],
    "1976": [
      {
        "round": 1,
        "name": "Brazilian Grand Prix",
        "country": "br"
      },
      {
        "round": 2,
        "name": "South African Grand Prix",
        "country": "za"
      },
      {
        "round": 3,
        "name": "United States Grand Prix West",
        "country": "us"
      },
      {
        "round": 4,
        "name": "Spanish Grand Prix",
        "country": "es"
      },
      {
        "round": 5,
        "name": "Belgian Grand Prix",
        "country": "be"
      },
      {
        "round": 6,
        "name": "Monaco Grand Prix",
        "country": "mc"
      },
      {
        "round": 7,
        "name": "Swedish Grand Prix",
        "country": "se"
      },
      {
        "round": 8,
        "name": "French Grand Prix",
        "country": "fr"
      },
      {
        "round": 9,
        "name": "British Grand Prix",
        "country": "gb"
      },
      {
        "round": 10,
        "name": "German Grand Prix",
        "country": "de"
      },
      {
        "round": 11,
        "name": "Austrian Grand Prix",
        "country": "at"
      },
      {
        "round": 12,
        "name": "Dutch Grand Prix",
        "country": "nl"
      },
      {
        "round": 13,
        "name": "Italian Grand Prix",
        "country": "it"
      },
      {
        "round": 14,
        "name": "Canadian Grand Prix",
        "country": "ca"
      },
      {
        "round": 15,
        "name": "United States Grand Prix",
        "country": "us"
      },
      {
        "round": 16,
        "name": "Japanese Grand Prix",
        "country": "jp"
      }
    ],
    "1988": [
      {
        "round": 1,
        "name": "Brazilian Grand Prix",
        "country": "br"
      },
      {
        "round": 2,
        "name": "San Marino Grand Prix",
        "country": "it"
      },
      {
        "round": 3,
        "name": "Monaco Grand Prix",
        "country": "mc"
      },
      {
        "round": 4,
        "name": "Mexican Grand Prix",
        "country": "mx"
      },
      {
        "round": 5,
        "name": "Canadian Grand Prix",
        "country": "ca"
      },
      {
        "round": 6,
        "name": "Detroit Grand Prix",
        "country": "us"
      },
      {
        "round": 7,
        "name": "French Grand Prix",
        "country": "fr"
      },
      {
        "round": 8,
        "name": "British Grand Prix",
        "country": "gb"
      },
      {
        "round": 9,
        "name": "German Grand Prix",
        "country": "de"
      },
      {
        "round": 10,
        "name": "Hungarian Grand Prix",
        "country": "hu"
      },
      {
        "round": 11,
        "name": "Belgian Grand Prix",
        "country": "be"
      },
      {
        "round": 12,
        "name": "Italian Grand Prix",
        "country": "it"
      },
      {
        "round": 13,
        "name": "Portuguese Grand Prix",
        "country": "pt"
      },
      {
        "round": 14,
        "name": "Spanish Grand Prix",
        "country": "es"
      },
      {
        "round": 15,
        "name": "Japanese Grand Prix",
        "country": "jp"
      },
      {
        "round": 16,
        "name": "Australian Grand Prix",
        "country": "au"
      }
    ],
    "1998": [
      {
        "round": 1,
        "name": "Australian Grand Prix",
        "country": "au"
      },
      {
        "round": 2,
        "name": "Brazilian Grand Prix",
        "country": "br"
      },
      {
        "round": 3,
        "name": "Argentine Grand Prix",
        "country": "ar"
      },
      {
        "round": 4,
        "name": "San Marino Grand Prix",
        "country": "it"
      },
      {
        "round": 5,
        "name": "Spanish Grand Prix",
        "country": "es"
      },
      {
        "round": 6,
        "name": "Monaco Grand Prix",
        "country": "mc"
      },
      {
        "round": 7,
        "name": "Canadian Grand Prix",
        "country": "ca"
      },
      {
        "round": 8,
        "name": "French Grand Prix",
        "country": "fr"
      },
      {
        "round": 9,
        "name": "British Grand Prix",
        "country": "gb"
      },
      {
        "round": 10,
        "name": "Austrian Grand Prix",
        "country": "at"
      },
      {
        "round": 11,
        "name": "German Grand Prix",
        "country": "de"
      },
      {
        "round": 12,
        "name": "Hungarian Grand Prix",
        "country": "hu"
      },
      {
        "round": 13,
        "name": "Belgian Grand Prix",
        "country": "be"
      },
      {
        "round": 14,
        "name": "Italian Grand Prix",
        "country": "it"
      },
      {
        "round": 15,
        "name": "Luxembourg Grand Prix",
        "country": "de"
      },
      {
        "round": 16,
        "name": "Japanese Grand Prix",
        "country": "jp"
      }
    ],
    "2008": [
      {
        "round": 1,
        "name": "Australian Grand Prix",
        "country": "au"
      },
      {
        "round": 2,
        "name": "Malaysian Grand Prix",
        "country": "my"
      },
      {
        "round": 3,
        "name": "Bahrain Grand Prix",
        "country": "bh"
      },
      {
        "round": 4,
        "name": "Spanish Grand Prix",
        "country": "es"
      },
      {
        "round": 5,
        "name": "Turkish Grand Prix",
        "country": "tr"
      },
      {
        "round": 6,
        "name": "Monaco Grand Prix",
        "country": "mc"
      },
      {
        "round": 7,
        "name": "Canadian Grand Prix",
        "country": "ca"
      },
      {
        "round": 8,
        "name": "French Grand Prix",
        "country": "fr"
      },
      {
        "round": 9,
        "name": "British Grand Prix",
        "country": "gb"
      },
      {
        "round": 10,
        "name": "German Grand Prix",
        "country": "de"
      },
      {
        "round": 11,
        "name": "Hungarian Grand Prix",
        "country": "hu"
      },
      {
        "round": 12,
        "name": "European Grand Prix",
        "country": "eu"
      },
      {
        "round": 13,
        "name": "Belgian Grand Prix",
        "country": "be"
      },
      {
        "round": 14,
        "name": "Italian Grand Prix",
        "country": "it"
      },
      {
        "round": 15,
        "name": "Singapore Grand Prix",
        "country": "sg"
      },
      {
        "round": 16,
        "name": "Japanese Grand Prix",
        "country": "jp"
      },
      {
        "round": 17,
        "name": "Chinese Grand Prix",
        "country": "cn"
      },
      {
        "round": 18,
        "name": "Brazilian Grand Prix",
        "country": "br"
      }
    ],
    "2016": [
      {
        "round": 1,
        "name": "Australian Grand Prix",
        "country": "au"
      },
      {
        "round": 2,
        "name": "Bahrain Grand Prix",
        "country": "bh"
      },
      {
        "round": 3,
        "name": "Chinese Grand Prix",
        "country": "cn"
      },
      {
        "round": 4,
        "name": "Russian Grand Prix",
        "country": "ru"
      },
      {
        "round": 5,
        "name": "Spanish Grand Prix",
        "country": "es"
      },
      {
        "round": 6,
        "name": "Monaco Grand Prix",
        "country": "mc"
      },
      {
        "round": 7,
        "name": "Canadian Grand Prix",
        "country": "ca"
      },
      {
        "round": 8,
        "name": "European Grand Prix",
        "country": "eu"
      },
      {
        "round": 9,
        "name": "Austrian Grand Prix",
        "country": "at"
      },
      {
        "round": 10,
        "name": "British Grand Prix",
        "country": "gb"
      },
      {
        "round": 11,
        "name": "Hungarian Grand Prix",
        "country": "hu"
      },
      {
        "round": 12,
        "name": "German Grand Prix",
        "country": "de"
      },
      {
        "round": 13,
        "name": "Belgian Grand Prix",
        "country": "be"
      },
      {
        "round": 14,
        "name": "Italian Grand Prix",
        "country": "it"
      },
      {
        "round": 15,
        "name": "Singapore Grand Prix",
        "country": "sg"
      },
      {
        "round": 16,
        "name": "Malaysian Grand Prix",
        "country": "my"
      },
      {
        "round": 17,
        "name": "Japanese Grand Prix",
        "country": "jp"
      },
      {
        "round": 18,
        "name": "United States Grand Prix",
        "country": "us"
      },
      {
        "round": 19,
        "name": "Mexican Grand Prix",
        "country": "mx"
      },
      {
        "round": 20,
        "name": "Brazilian Grand Prix",
        "country": "br"
      },
      {
        "round": 21,
        "name": "Abu Dhabi Grand Prix",
        "country": "ae"
      }
    ],
    "2024": [
      {
        "round": 1,
        "name": "Bahrain Grand Prix",
        "country": "bh"
      },
      {
        "round": 2,
        "name": "Saudi Arabian Grand Prix",
        "country": "sa"
      },
      {
        "round": 3,
        "name": "Australian Grand Prix",
        "country": "au"
      },
      {
        "round": 4,
        "name": "Japanese Grand Prix",
        "country": "jp"
      },
      {
        "round": 5,
        "name": "Chinese Grand Prix",
        "country": "cn"
      },
      {
        "round": 6,
        "name": "Miami Grand Prix",
        "country": "us"
      },
      {
        "round": 7,
        "name": "Emilia Romagna Grand Prix",
        "country": "it"
      },
      {
        "round": 8,
        "name": "Monaco Grand Prix",
        "country": "mc"
      },
      {
        "round": 9,
        "name": "Canadian Grand Prix",
        "country": "ca"
      },
      {
        "round": 10,
        "name": "Spanish Grand Prix",
        "country": "es"
      },
      {
        "round": 11,
        "name": "Austrian Grand Prix",
        "country": "at"
      },
      {
        "round": 12,
        "name": "British Grand Prix",
        "country": "gb"
      },
      {
        "round": 13,
        "name": "Hungarian Grand Prix",
        "country": "hu"
      },
      {
        "round": 14,
        "name": "Belgian Grand Prix",
        "country": "be"
      },
      {
        "round": 15,
        "name": "Dutch Grand Prix",
        "country": "nl"
      },
      {
        "round": 16,
        "name": "Italian Grand Prix",
        "country": "it"
      },
      {
        "round": 17,
        "name": "Azerbaijan Grand Prix",
        "country": "az"
      },
      {
        "round": 18,
        "name": "Singapore Grand Prix",
        "country": "sg"
      },
      {
        "round": 19,
        "name": "United States Grand Prix",
        "country": "us"
      },
      {
        "round": 20,
        "name": "Mexico City Grand Prix",
        "country": "mx"
      },
      {
        "round": 21,
        "name": "São Paulo Grand Prix",
        "country": "br"
      },
      {
        "round": 22,
        "name": "Las Vegas Grand Prix",
        "country": "us"
      },
      {
        "round": 23,
        "name": "Qatar Grand Prix",
        "country": "qa"
      },
      {
        "round": 24,
        "name": "Abu Dhabi Grand Prix",
        "country": "ae"
      }
    ]
  },
  "lineupsByYear": {
    "1955": [
      {
        "id": "ferrari",
        "team": "Ferrari",
        "rating": 99,
        "races": 6,
        "drivers": [
          {
            "name": "Maurice Trintignant",
            "rating": 65,
            "races": 6
          },
          {
            "name": "Nino Farina",
            "rating": 67,
            "races": 4
          },
          {
            "name": "Eugenio Castellotti",
            "rating": 56,
            "races": 3
          }
        ]
      },
      {
        "id": "maserati",
        "team": "Maserati",
        "rating": 77,
        "races": 6,
        "drivers": [
          {
            "name": "Jean Behra",
            "rating": 61,
            "races": 6
          },
          {
            "name": "Luigi Musso",
            "rating": 61,
            "races": 6
          },
          {
            "name": "Roberto Mieres",
            "rating": 55,
            "races": 6
          }
        ]
      },
      {
        "id": "mercedes",
        "team": "Mercedes",
        "rating": 99,
        "races": 6,
        "drivers": [
          {
            "name": "Juan Fangio",
            "rating": 99,
            "races": 6
          },
          {
            "name": "Stirling Moss",
            "rating": 76,
            "races": 6
          },
          {
            "name": "Karl Kling",
            "rating": 55,
            "races": 5
          }
        ]
      },
      {
        "id": "gordini",
        "team": "Gordini",
        "rating": 61,
        "races": 3,
        "drivers": [
          {
            "name": "Hernando da Silva Ramos",
            "rating": 55,
            "races": 3
          },
          {
            "name": "Jacques Pollet",
            "rating": 48,
            "races": 3
          },
          {
            "name": "Robert Manzon",
            "rating": 64,
            "races": 3
          }
        ]
      },
      {
        "id": "lancia",
        "team": "Lancia",
        "rating": 51,
        "races": 3,
        "drivers": [
          {
            "name": "Eugenio Castellotti",
            "rating": 56,
            "races": 3
          },
          {
            "name": "Alberto Ascari",
            "rating": 87,
            "races": 2
          },
          {
            "name": "Luigi Villoresi",
            "rating": 68,
            "races": 2
          }
        ]
      },
      {
        "id": "vanwall",
        "team": "Vanwall",
        "rating": 58,
        "races": 2,
        "drivers": [
          {
            "name": "Harry Schell",
            "rating": 55,
            "races": 2
          },
          {
            "name": "Ken Wharton",
            "rating": 52,
            "races": 2
          },
          {
            "name": "Mike Hawthorn",
            "rating": 79,
            "races": 2
          }
        ]
      },
      {
        "id": "arzani-volpini",
        "team": "Arzani-Volpini",
        "rating": 46,
        "races": 1,
        "drivers": [
          {
            "name": "Luigi Piotti",
            "rating": 60,
            "races": 1
          }
        ]
      },
      {
        "id": "connaught",
        "team": "Connaught",
        "rating": 55,
        "races": 1,
        "drivers": [
          {
            "name": "Jack Fairman",
            "rating": 52,
            "races": 1
          },
          {
            "name": "Kenneth McAlpine",
            "rating": 58,
            "races": 1
          },
          {
            "name": "Leslie Marr",
            "rating": 46,
            "races": 1
          }
        ]
      },
      {
        "id": "cooper",
        "team": "Cooper",
        "rating": 56,
        "races": 1,
        "drivers": [
          {
            "name": "Jack Brabham",
            "rating": 91,
            "races": 1
          }
        ]
      },
      {
        "id": "epperly",
        "team": "Epperly",
        "rating": 63,
        "races": 1,
        "drivers": [
          {
            "name": "Jim Rathmann",
            "rating": 66,
            "races": 1
          }
        ]
      },
      {
        "id": "hwm",
        "team": "HWM",
        "rating": 49,
        "races": 1,
        "drivers": [
          {
            "name": "Ted Whiteaway",
            "rating": 54,
            "races": 1
          }
        ]
      },
      {
        "id": "kurtis-kraft",
        "team": "Kurtis Kraft",
        "rating": 65,
        "races": 1,
        "drivers": [
          {
            "name": "Al Herman",
            "rating": 51,
            "races": 1
          },
          {
            "name": "Al Keller",
            "rating": 47,
            "races": 1
          },
          {
            "name": "Andy Linden",
            "rating": 61,
            "races": 1
          }
        ]
      },
      {
        "id": "kuzma",
        "team": "Kuzma",
        "rating": 59,
        "races": 1,
        "drivers": [
          {
            "name": "Duane Carter",
            "rating": 61,
            "races": 1
          },
          {
            "name": "Jimmy Bryan",
            "rating": 54,
            "races": 1
          },
          {
            "name": "Johnny Thomson",
            "rating": 62,
            "races": 1
          }
        ]
      },
      {
        "id": "pankratz",
        "team": "Pankratz",
        "rating": 59,
        "races": 1,
        "drivers": [
          {
            "name": "Jimmy Reece",
            "rating": 57,
            "races": 1
          }
        ]
      },
      {
        "id": "pawl",
        "team": "Pawl",
        "rating": 54,
        "races": 1,
        "drivers": [
          {
            "name": "Eddie Russo",
            "rating": 61,
            "races": 1
          }
        ]
      },
      {
        "id": "phillips",
        "team": "Phillips",
        "rating": 59,
        "races": 1,
        "drivers": [
          {
            "name": "Don Freeland",
            "rating": 63,
            "races": 1
          }
        ]
      },
      {
        "id": "schroeder",
        "team": "Schroeder",
        "rating": 53,
        "races": 1,
        "drivers": [
          {
            "name": "Keith Andrews",
            "rating": 50,
            "races": 1
          }
        ]
      },
      {
        "id": "stevens",
        "team": "Stevens",
        "rating": 49,
        "races": 1,
        "drivers": [
          {
            "name": "Jerry Hoyt",
            "rating": 58,
            "races": 1
          }
        ]
      },
      {
        "id": "trevis",
        "team": "Trevis",
        "rating": 48,
        "races": 1,
        "drivers": [
          {
            "name": "Eddie Johnson",
            "rating": 55,
            "races": 1
          },
          {
            "name": "Shorty Templeman",
            "rating": 51,
            "races": 1
          }
        ]
      }
    ],
    "1965": [
      {
        "id": "brm",
        "team": "BRM",
        "rating": 92,
        "races": 10,
        "drivers": [
          {
            "name": "Graham Hill",
            "rating": 99,
            "races": 10
          },
          {
            "name": "Jackie Stewart",
            "rating": 99,
            "races": 10
          },
          {
            "name": "Masten Gregory",
            "rating": 63,
            "races": 4
          }
        ],
        "points": 45.0,
        "standingPosition": 2
      },
      {
        "id": "brabham-brm",
        "team": "Brabham-BRM",
        "rating": 55,
        "races": 10,
        "drivers": [
          {
            "name": "Jo Siffert",
            "rating": 57,
            "races": 10
          },
          {
            "name": "Frank Gardner",
            "rating": 54,
            "races": 7
          },
          {
            "name": "Ian Raby",
            "rating": 58,
            "races": 1
          }
        ],
        "points": 5.0,
        "standingPosition": 7
      },
      {
        "id": "brabham-climax",
        "team": "Brabham-Climax",
        "rating": 64,
        "races": 10,
        "drivers": [
          {
            "name": "Jo Bonnier",
            "rating": 67,
            "races": 10
          },
          {
            "name": "Dan Gurney",
            "rating": 75,
            "races": 9
          },
          {
            "name": "Jack Brabham",
            "rating": 91,
            "races": 7
          }
        ],
        "points": 27.0,
        "standingPosition": 3
      },
      {
        "id": "cooper-climax",
        "team": "Cooper-Climax",
        "rating": 84,
        "races": 10,
        "drivers": [
          {
            "name": "Bruce McLaren",
            "rating": 67,
            "races": 10
          },
          {
            "name": "Jochen Rindt",
            "rating": 79,
            "races": 10
          },
          {
            "name": "Alex Blignaut",
            "rating": 51,
            "races": 1
          }
        ],
        "points": 14.0,
        "standingPosition": 5
      },
      {
        "id": "ferrari",
        "team": "Ferrari",
        "rating": 99,
        "races": 10,
        "drivers": [
          {
            "name": "Lorenzo Bandini",
            "rating": 59,
            "races": 10
          },
          {
            "name": "John Surtees",
            "rating": 78,
            "races": 8
          },
          {
            "name": "Pedro Rodríguez",
            "rating": 58,
            "races": 2
          }
        ],
        "points": 26.0,
        "standingPosition": 4
      },
      {
        "id": "lotus-climax",
        "team": "Lotus-Climax",
        "rating": 92,
        "races": 9,
        "drivers": [
          {
            "name": "Jim Clark",
            "rating": 86,
            "races": 9
          },
          {
            "name": "Mike Spence",
            "rating": 53,
            "races": 9
          },
          {
            "name": "Moisés Solana",
            "rating": 59,
            "races": 2
          }
        ],
        "points": 54.0,
        "standingPosition": 1
      },
      {
        "id": "honda",
        "team": "Honda",
        "rating": 52,
        "races": 8,
        "drivers": [
          {
            "name": "Richie Ginther",
            "rating": 65,
            "races": 8
          },
          {
            "name": "Ronnie Bucknum",
            "rating": 51,
            "races": 6
          }
        ],
        "points": 11.0,
        "standingPosition": 6
      },
      {
        "id": "lotus-brm",
        "team": "Lotus-BRM",
        "rating": 63,
        "races": 8,
        "drivers": [
          {
            "name": "Richard Attwood",
            "rating": 59,
            "races": 8
          },
          {
            "name": "Innes Ireland",
            "rating": 68,
            "races": 7
          },
          {
            "name": "Chris Amon",
            "rating": 67,
            "races": 2
          }
        ],
        "points": 2.0,
        "standingPosition": 8
      },
      {
        "id": "alfa-romeo",
        "team": "Alfa Romeo",
        "rating": 70,
        "races": 1,
        "drivers": [
          {
            "name": "Peter de Klerk",
            "rating": 55,
            "races": 1
          }
        ],
        "points": 0.0,
        "standingPosition": 10
      },
      {
        "id": "brabham-ford",
        "team": "Brabham-Ford",
        "rating": 68,
        "races": 1,
        "drivers": [
          {
            "name": "David Prophet",
            "rating": 47,
            "races": 1
          },
          {
            "name": "Paul Hawkins",
            "rating": 57,
            "races": 1
          }
        ],
        "points": 0.0,
        "standingPosition": 9
      },
      {
        "id": "cooper-ford",
        "team": "Cooper-Ford",
        "rating": 57,
        "races": 1,
        "drivers": [
          {
            "name": "Alan Rollinson",
            "rating": 51,
            "races": 1
          },
          {
            "name": "Trevor Blokdyk",
            "rating": 53,
            "races": 1
          }
        ],
        "points": 0.0,
        "standingPosition": 12
      },
      {
        "id": "cooper-maserati",
        "team": "Cooper-Maserati",
        "rating": 66,
        "races": 1,
        "drivers": [
          {
            "name": "David Clapham",
            "rating": 56,
            "races": 1
          }
        ],
        "points": 0.0,
        "standingPosition": 16
      },
      {
        "id": "lds-alfa-romeo",
        "team": "LDS-Alfa Romeo",
        "rating": 51,
        "races": 1,
        "drivers": [
          {
            "name": "Jackie Pretorius",
            "rating": 51,
            "races": 1
          },
          {
            "name": "Sam Tingle",
            "rating": 48,
            "races": 1
          }
        ],
        "points": 0.0,
        "standingPosition": 11
      },
      {
        "id": "lds-climax",
        "team": "LDS-Climax",
        "rating": 48,
        "races": 1,
        "drivers": [
          {
            "name": "Doug Serrurier",
            "rating": 46,
            "races": 1
          }
        ],
        "points": 0.0,
        "standingPosition": 13
      },
      {
        "id": "lotus-ford",
        "team": "Lotus-Ford",
        "rating": 71,
        "races": 1,
        "drivers": [
          {
            "name": "Brausch Niemann",
            "rating": 57,
            "races": 1
          },
          {
            "name": "Dave Charlton",
            "rating": 58,
            "races": 1
          }
        ],
        "points": 0.0,
        "standingPosition": 14
      },
      {
        "id": "re",
        "team": "RE",
        "rating": 52,
        "races": 1,
        "drivers": [
          {
            "name": "Ray Reed",
            "rating": 50,
            "races": 1
          }
        ],
        "points": 0.0,
        "standingPosition": 15
      }
    ],
    "1976": [
      {
        "id": "brabham-alfa-romeo",
        "team": "Brabham-Alfa Romeo",
        "rating": 49,
        "races": 16,
        "drivers": [
          {
            "name": "Carlos Pace",
            "rating": 57,
            "races": 16
          },
          {
            "name": "Carlos Reutemann",
            "rating": 72,
            "races": 12
          },
          {
            "name": "Larry Perkins",
            "rating": 51,
            "races": 3
          }
        ],
        "points": 9.0,
        "standingPosition": 9
      },
      {
        "id": "fittipaldi",
        "team": "Fittipaldi",
        "rating": 52,
        "races": 16,
        "drivers": [
          {
            "name": "Emerson Fittipaldi",
            "rating": 83,
            "races": 16
          },
          {
            "name": "Ingo Hoffmann",
            "rating": 59,
            "races": 4
          }
        ],
        "points": 3.0,
        "standingPosition": 11
      },
      {
        "id": "ligier",
        "team": "Ligier",
        "rating": 75,
        "races": 16,
        "drivers": [
          {
            "name": "Jacques Laffite",
            "rating": 76,
            "races": 16
          }
        ],
        "points": 20.0,
        "standingPosition": 6
      },
      {
        "id": "march",
        "team": "March",
        "rating": 74,
        "races": 16,
        "drivers": [
          {
            "name": "Hans-Joachim Stuck",
            "rating": 65,
            "races": 16
          },
          {
            "name": "Vittorio Brambilla",
            "rating": 54,
            "races": 16
          },
          {
            "name": "Ronnie Peterson",
            "rating": 74,
            "races": 15
          }
        ],
        "points": 19.0,
        "standingPosition": 7
      },
      {
        "id": "mclaren",
        "team": "McLaren",
        "rating": 99,
        "races": 16,
        "drivers": [
          {
            "name": "James Hunt",
            "rating": 80,
            "races": 16
          },
          {
            "name": "Jochen Mass",
            "rating": 70,
            "races": 16
          }
        ],
        "points": 74.0,
        "standingPosition": 2
      },
      {
        "id": "penske",
        "team": "Penske",
        "rating": 49,
        "races": 16,
        "drivers": [
          {
            "name": "John Watson",
            "rating": 66,
            "races": 16
          },
          {
            "name": "Boy Lunger",
            "rating": 53,
            "races": 1
          }
        ],
        "points": 20.0,
        "standingPosition": 5
      },
      {
        "id": "shadow",
        "team": "Shadow",
        "rating": 61,
        "races": 16,
        "drivers": [
          {
            "name": "Jean-Pierre Jarier",
            "rating": 55,
            "races": 16
          },
          {
            "name": "Tom Pryce",
            "rating": 62,
            "races": 16
          },
          {
            "name": "Mike Wilds",
            "rating": 50,
            "races": 1
          }
        ],
        "points": 10.0,
        "standingPosition": 8
      },
      {
        "id": "tyrrell",
        "team": "Tyrrell",
        "rating": 95,
        "races": 16,
        "drivers": [
          {
            "name": "Jody Scheckter",
            "rating": 73,
            "races": 16
          },
          {
            "name": "Patrick Depailler",
            "rating": 64,
            "races": 16
          },
          {
            "name": "Alessandro Pesenti-Rossi",
            "rating": 47,
            "races": 4
          }
        ],
        "points": 71.0,
        "standingPosition": 3
      },
      {
        "id": "ferrari",
        "team": "Ferrari",
        "rating": 99,
        "races": 15,
        "drivers": [
          {
            "name": "Clay Regazzoni",
            "rating": 77,
            "races": 15
          },
          {
            "name": "Niki Lauda",
            "rating": 99,
            "races": 14
          },
          {
            "name": "Carlos Reutemann",
            "rating": 72,
            "races": 1
          }
        ],
        "points": 83.0,
        "standingPosition": 1
      },
      {
        "id": "hesketh",
        "team": "Hesketh",
        "rating": 50,
        "races": 15,
        "drivers": [
          {
            "name": "Harald Ertl",
            "rating": 50,
            "races": 15
          },
          {
            "name": "Guy Edwards",
            "rating": 51,
            "races": 6
          },
          {
            "name": "Alex Ribeiro",
            "rating": 48,
            "races": 1
          }
        ],
        "points": 0.0,
        "standingPosition": 14
      },
      {
        "id": "team-lotus",
        "team": "Team Lotus",
        "rating": 99,
        "races": 15,
        "drivers": [
          {
            "name": "Gunnar Nilsson",
            "rating": 59,
            "races": 15
          },
          {
            "name": "Mario Andretti",
            "rating": 85,
            "races": 13
          },
          {
            "name": "Bob Evans",
            "rating": 48,
            "races": 2
          }
        ],
        "points": 29.0,
        "standingPosition": 4
      },
      {
        "id": "surtees",
        "team": "Surtees",
        "rating": 63,
        "races": 14,
        "drivers": [
          {
            "name": "Alan Jones",
            "rating": 72,
            "races": 14
          },
          {
            "name": "Brett Lunger",
            "rating": 50,
            "races": 12
          },
          {
            "name": "Henri Pescarolo",
            "rating": 53,
            "races": 9
          }
        ],
        "points": 7.0,
        "standingPosition": 10
      },
      {
        "id": "ensign",
        "team": "Ensign",
        "rating": 46,
        "races": 8,
        "drivers": [
          {
            "name": "Chris Amon",
            "rating": 67,
            "races": 8
          },
          {
            "name": "Jacky Ickx",
            "rating": 72,
            "races": 4
          },
          {
            "name": "Hans Binder",
            "rating": 49,
            "races": 1
          }
        ],
        "points": 2.0,
        "standingPosition": 12
      },
      {
        "id": "wolf",
        "team": "Wolf",
        "rating": 65,
        "races": 8,
        "drivers": [
          {
            "name": "Jacky Ickx",
            "rating": 72,
            "races": 8
          },
          {
            "name": "Arturo Merzario",
            "rating": 52,
            "races": 7
          },
          {
            "name": "Michel Leclère",
            "rating": 52,
            "races": 7
          }
        ],
        "points": 0.0,
        "standingPosition": 15
      },
      {
        "id": "boro",
        "team": "Boro",
        "rating": 49,
        "races": 6,
        "drivers": [
          {
            "name": "Larry Perkins",
            "rating": 51,
            "races": 6
          }
        ],
        "points": 0.0,
        "standingPosition": 16
      },
      {
        "id": "brabham-ford",
        "team": "Brabham-Ford",
        "rating": 68,
        "races": 5,
        "drivers": [
          {
            "name": "Loris Kessel",
            "rating": 53,
            "races": 5
          },
          {
            "name": "Lella Lombardi",
            "rating": 49,
            "races": 3
          },
          {
            "name": "Bob Evans",
            "rating": 48,
            "races": 1
          }
        ],
        "points": 0.0,
        "standingPosition": 19
      },
      {
        "id": "parnelli",
        "team": "Parnelli",
        "rating": 59,
        "races": 2,
        "drivers": [
          {
            "name": "Mario Andretti",
            "rating": 85,
            "races": 2
          }
        ],
        "points": 1.0,
        "standingPosition": 13
      },
      {
        "id": "brm",
        "team": "BRM",
        "rating": 92,
        "races": 1,
        "drivers": [
          {
            "name": "Ian Ashley",
            "rating": 60,
            "races": 1
          }
        ],
        "points": 0.0,
        "standingPosition": 20
      },
      {
        "id": "kojima",
        "team": "Kojima",
        "rating": 52,
        "races": 1,
        "drivers": [
          {
            "name": "Masahiro Hasemi",
            "rating": 48,
            "races": 1
          }
        ],
        "points": 0.0,
        "standingPosition": 18
      },
      {
        "id": "maki",
        "team": "Maki",
        "rating": 49,
        "races": 1,
        "drivers": [
          {
            "name": "Tony Trimmer",
            "rating": 61,
            "races": 1
          }
        ],
        "points": 0.0,
        "standingPosition": 21
      },
      {
        "id": "williams",
        "team": "Williams",
        "rating": 99,
        "races": 1,
        "drivers": [
          {
            "name": "Emilio Zapico",
            "rating": 59,
            "races": 1
          },
          {
            "name": "Renzo Zorzi",
            "rating": 51,
            "races": 1
          }
        ],
        "points": 0.0,
        "standingPosition": 17
      }
    ],
    "1988": [
      {
        "id": "ags",
        "team": "AGS",
        "rating": 57,
        "races": 16,
        "drivers": [
          {
            "name": "Philippe Streiff",
            "rating": 60,
            "races": 16
          }
        ],
        "points": 0.0,
        "standingPosition": 13
      },
      {
        "id": "arrows",
        "team": "Arrows",
        "rating": 64,
        "races": 16,
        "drivers": [
          {
            "name": "Derek Warwick",
            "rating": 59,
            "races": 16
          },
          {
            "name": "Eddie Cheever",
            "rating": 65,
            "races": 16
          }
        ],
        "points": 23.0,
        "standingPosition": 5
      },
      {
        "id": "benetton",
        "team": "Benetton",
        "rating": 85,
        "races": 16,
        "drivers": [
          {
            "name": "Alessandro Nannini",
            "rating": 66,
            "races": 16
          },
          {
            "name": "Thierry Boutsen",
            "rating": 71,
            "races": 16
          }
        ],
        "points": 39.0,
        "standingPosition": 3
      },
      {
        "id": "coloni",
        "team": "Coloni",
        "rating": 47,
        "races": 16,
        "drivers": [
          {
            "name": "Gabriele Tarquini",
            "rating": 51,
            "races": 16
          }
        ],
        "points": 0.0,
        "standingPosition": 14
      },
      {
        "id": "dallara",
        "team": "Dallara",
        "rating": 54,
        "races": 16,
        "drivers": [
          {
            "name": "Alex Caffi",
            "rating": 55,
            "races": 16
          }
        ],
        "points": 0.0,
        "standingPosition": 12
      },
      {
        "id": "euro-brun",
        "team": "Euro Brun",
        "rating": 52,
        "races": 16,
        "drivers": [
          {
            "name": "Oscar Larrauri",
            "rating": 58,
            "races": 16
          },
          {
            "name": "Stefano Modena",
            "rating": 64,
            "races": 16
          }
        ],
        "points": 0.0,
        "standingPosition": 17
      },
      {
        "id": "ferrari",
        "team": "Ferrari",
        "rating": 99,
        "races": 16,
        "drivers": [
          {
            "name": "Gerhard Berger",
            "rating": 80,
            "races": 16
          },
          {
            "name": "Michele Alboreto",
            "rating": 75,
            "races": 16
          }
        ],
        "points": 65.0,
        "standingPosition": 2
      },
      {
        "id": "larrousse",
        "team": "Larrousse",
        "rating": 53,
        "races": 16,
        "drivers": [
          {
            "name": "Philippe Alliot",
            "rating": 52,
            "races": 16
          },
          {
            "name": "Yannick Dalmas",
            "rating": 58,
            "races": 14
          },
          {
            "name": "Aguri Suzuki",
            "rating": 55,
            "races": 1
          }
        ],
        "points": 0.0,
        "standingPosition": 11
      },
      {
        "id": "ligier",
        "team": "Ligier",
        "rating": 75,
        "races": 16,
        "drivers": [
          {
            "name": "René Arnoux",
            "rating": 70,
            "races": 16
          },
          {
            "name": "Stefan Johansson",
            "rating": 67,
            "races": 16
          }
        ],
        "points": 0.0,
        "standingPosition": 15
      },
      {
        "id": "march",
        "team": "March",
        "rating": 74,
        "races": 16,
        "drivers": [
          {
            "name": "Ivan Capelli",
            "rating": 60,
            "races": 16
          },
          {
            "name": "Maurício Gugelmin",
            "rating": 54,
            "races": 16
          }
        ],
        "points": 22.0,
        "standingPosition": 6
      },
      {
        "id": "mclaren",
        "team": "McLaren",
        "rating": 99,
        "races": 16,
        "drivers": [
          {
            "name": "Alain Prost",
            "rating": 99,
            "races": 16
          },
          {
            "name": "Ayrton Senna",
            "rating": 99,
            "races": 16
          }
        ],
        "points": 199.0,
        "standingPosition": 1
      },
      {
        "id": "minardi",
        "team": "Minardi",
        "rating": 49,
        "races": 16,
        "drivers": [
          {
            "name": "Luis Pérez-Sala",
            "rating": 49,
            "races": 16
          },
          {
            "name": "Pierluigi Martini",
            "rating": 52,
            "races": 11
          },
          {
            "name": "Adrián Campos",
            "rating": 60,
            "races": 5
          }
        ],
        "points": 1.0,
        "standingPosition": 10
      },
      {
        "id": "osella",
        "team": "Osella",
        "rating": 62,
        "races": 16,
        "drivers": [
          {
            "name": "Nicola Larini",
            "rating": 52,
            "races": 16
          }
        ],
        "points": 0.0,
        "standingPosition": 16
      },
      {
        "id": "rial",
        "team": "Rial",
        "rating": 53,
        "races": 16,
        "drivers": [
          {
            "name": "Andrea de Cesaris",
            "rating": 59,
            "races": 16
          }
        ],
        "points": 3.0,
        "standingPosition": 9
      },
      {
        "id": "team-lotus",
        "team": "Team Lotus",
        "rating": 99,
        "races": 16,
        "drivers": [
          {
            "name": "Nelson Piquet",
            "rating": 99,
            "races": 16
          },
          {
            "name": "Satoru Nakajima",
            "rating": 58,
            "races": 16
          }
        ],
        "points": 23.0,
        "standingPosition": 4
      },
      {
        "id": "tyrrell",
        "team": "Tyrrell",
        "rating": 95,
        "races": 16,
        "drivers": [
          {
            "name": "Jonathan Palmer",
            "rating": 52,
            "races": 16
          },
          {
            "name": "Julian Bailey",
            "rating": 54,
            "races": 16
          }
        ],
        "points": 5.0,
        "standingPosition": 8
      },
      {
        "id": "williams",
        "team": "Williams",
        "rating": 99,
        "races": 16,
        "drivers": [
          {
            "name": "Riccardo Patrese",
            "rating": 72,
            "races": 16
          },
          {
            "name": "Nigel Mansell",
            "rating": 92,
            "races": 14
          },
          {
            "name": "Jean-Louis Schlesser",
            "rating": 56,
            "races": 1
          }
        ],
        "points": 20.0,
        "standingPosition": 7
      },
      {
        "id": "zakspeed",
        "team": "Zakspeed",
        "rating": 50,
        "races": 16,
        "drivers": [
          {
            "name": "Piercarlo Ghinzani",
            "rating": 62,
            "races": 16
          },
          {
            "name": "Bernd Schneider",
            "rating": 55,
            "races": 15
          }
        ],
        "points": 0.0,
        "standingPosition": 18
      }
    ],
    "1998": [
      {
        "id": "arrows",
        "team": "Arrows",
        "rating": 64,
        "races": 16,
        "drivers": [
          {
            "name": "Mika Salo",
            "rating": 56,
            "races": 16
          },
          {
            "name": "Pedro Diniz",
            "rating": 52,
            "races": 16
          }
        ],
        "points": 6.0,
        "standingPosition": 7
      },
      {
        "id": "benetton",
        "team": "Benetton",
        "rating": 85,
        "races": 16,
        "drivers": [
          {
            "name": "Alexander Wurz",
            "rating": 53,
            "races": 16
          },
          {
            "name": "Giancarlo Fisichella",
            "rating": 65,
            "races": 16
          }
        ],
        "points": 33.0,
        "standingPosition": 5
      },
      {
        "id": "ferrari",
        "team": "Ferrari",
        "rating": 99,
        "races": 16,
        "drivers": [
          {
            "name": "Eddie Irvine",
            "rating": 65,
            "races": 16
          },
          {
            "name": "Michael Schumacher",
            "rating": 99,
            "races": 16
          }
        ],
        "points": 133.0,
        "standingPosition": 2
      },
      {
        "id": "jordan",
        "team": "Jordan",
        "rating": 70,
        "races": 16,
        "drivers": [
          {
            "name": "Damon Hill",
            "rating": 92,
            "races": 16
          },
          {
            "name": "Ralf Schumacher",
            "rating": 70,
            "races": 16
          }
        ],
        "points": 34.0,
        "standingPosition": 4
      },
      {
        "id": "mclaren",
        "team": "McLaren",
        "rating": 99,
        "races": 16,
        "drivers": [
          {
            "name": "David Coulthard",
            "rating": 81,
            "races": 16
          },
          {
            "name": "Mika Häkkinen",
            "rating": 99,
            "races": 16
          }
        ],
        "points": 156.0,
        "standingPosition": 1
      },
      {
        "id": "minardi",
        "team": "Minardi",
        "rating": 49,
        "races": 16,
        "drivers": [
          {
            "name": "Esteban Tuero",
            "rating": 59,
            "races": 16
          },
          {
            "name": "Shinji Nakano",
            "rating": 46,
            "races": 16
          }
        ],
        "points": 0.0,
        "standingPosition": 10
      },
      {
        "id": "prost",
        "team": "Prost",
        "rating": 55,
        "races": 16,
        "drivers": [
          {
            "name": "Jarno Trulli",
            "rating": 69,
            "races": 16
          },
          {
            "name": "Olivier Panis",
            "rating": 63,
            "races": 16
          }
        ],
        "points": 1.0,
        "standingPosition": 9
      },
      {
        "id": "sauber",
        "team": "Sauber",
        "rating": 63,
        "races": 16,
        "drivers": [
          {
            "name": "Jean Alesi",
            "rating": 68,
            "races": 16
          },
          {
            "name": "Johnny Herbert",
            "rating": 67,
            "races": 16
          }
        ],
        "points": 10.0,
        "standingPosition": 6
      },
      {
        "id": "stewart",
        "team": "Stewart",
        "rating": 59,
        "races": 16,
        "drivers": [
          {
            "name": "Rubens Barrichello",
            "rating": 87,
            "races": 16
          },
          {
            "name": "Jos Verstappen",
            "rating": 54,
            "races": 9
          },
          {
            "name": "Jan Magnussen",
            "rating": 57,
            "races": 7
          }
        ],
        "points": 5.0,
        "standingPosition": 8
      },
      {
        "id": "tyrrell",
        "team": "Tyrrell",
        "rating": 95,
        "races": 16,
        "drivers": [
          {
            "name": "Toranosuke Takagi",
            "rating": 54,
            "races": 16
          },
          {
            "name": "Ricardo Rosset",
            "rating": 51,
            "races": 13
          }
        ],
        "points": 0.0,
        "standingPosition": 11
      },
      {
        "id": "williams",
        "team": "Williams",
        "rating": 99,
        "races": 16,
        "drivers": [
          {
            "name": "Heinz-Harald Frentzen",
            "rating": 71,
            "races": 16
          },
          {
            "name": "Jacques Villeneuve",
            "rating": 85,
            "races": 16
          }
        ],
        "points": 38.0,
        "standingPosition": 3
      }
    ],
    "2008": [
      {
        "id": "bmw-sauber",
        "team": "BMW Sauber",
        "rating": 67,
        "races": 18,
        "drivers": [
          {
            "name": "Nick Heidfeld",
            "rating": 65,
            "races": 18
          },
          {
            "name": "Robert Kubica",
            "rating": 63,
            "races": 18
          }
        ],
        "points": 135.0,
        "standingPosition": 3
      },
      {
        "id": "ferrari",
        "team": "Ferrari",
        "rating": 99,
        "races": 18,
        "drivers": [
          {
            "name": "Felipe Massa",
            "rating": 80,
            "races": 18
          },
          {
            "name": "Kimi Räikkönen",
            "rating": 99,
            "races": 18
          }
        ],
        "points": 172.0,
        "standingPosition": 1
      },
      {
        "id": "force-india",
        "team": "Force India",
        "rating": 63,
        "races": 18,
        "drivers": [
          {
            "name": "Adrian Sutil",
            "rating": 56,
            "races": 18
          },
          {
            "name": "Giancarlo Fisichella",
            "rating": 65,
            "races": 18
          }
        ],
        "points": 0.0,
        "standingPosition": 10
      },
      {
        "id": "honda",
        "team": "Honda",
        "rating": 52,
        "races": 18,
        "drivers": [
          {
            "name": "Jenson Button",
            "rating": 93,
            "races": 18
          },
          {
            "name": "Rubens Barrichello",
            "rating": 87,
            "races": 18
          }
        ],
        "points": 14.0,
        "standingPosition": 9
      },
      {
        "id": "mclaren",
        "team": "McLaren",
        "rating": 99,
        "races": 18,
        "drivers": [
          {
            "name": "Heikki Kovalainen",
            "rating": 65,
            "races": 18
          },
          {
            "name": "Lewis Hamilton",
            "rating": 99,
            "races": 18
          }
        ],
        "points": 151.0,
        "standingPosition": 2
      },
      {
        "id": "red-bull",
        "team": "Red Bull",
        "rating": 99,
        "races": 18,
        "drivers": [
          {
            "name": "David Coulthard",
            "rating": 81,
            "races": 18
          },
          {
            "name": "Mark Webber",
            "rating": 70,
            "races": 18
          }
        ],
        "points": 29.0,
        "standingPosition": 7
      },
      {
        "id": "renault",
        "team": "Renault",
        "rating": 99,
        "races": 18,
        "drivers": [
          {
            "name": "Fernando Alonso",
            "rating": 99,
            "races": 18
          },
          {
            "name": "Nelson Piquet Jr.",
            "rating": 57,
            "races": 18
          }
        ],
        "points": 80.0,
        "standingPosition": 4
      },
      {
        "id": "toro-rosso",
        "team": "Toro Rosso",
        "rating": 51,
        "races": 18,
        "drivers": [
          {
            "name": "Sebastian Vettel",
            "rating": 99,
            "races": 18
          },
          {
            "name": "Sébastien Bourdais",
            "rating": 49,
            "races": 18
          }
        ],
        "points": 39.0,
        "standingPosition": 6
      },
      {
        "id": "toyota",
        "team": "Toyota",
        "rating": 54,
        "races": 18,
        "drivers": [
          {
            "name": "Jarno Trulli",
            "rating": 69,
            "races": 18
          },
          {
            "name": "Timo Glock",
            "rating": 52,
            "races": 18
          }
        ],
        "points": 56.0,
        "standingPosition": 5
      },
      {
        "id": "williams",
        "team": "Williams",
        "rating": 99,
        "races": 18,
        "drivers": [
          {
            "name": "Kazuki Nakajima",
            "rating": 60,
            "races": 18
          },
          {
            "name": "Nico Rosberg",
            "rating": 93,
            "races": 18
          }
        ],
        "points": 26.0,
        "standingPosition": 8
      },
      {
        "id": "super-aguri",
        "team": "Super Aguri",
        "rating": 59,
        "races": 4,
        "drivers": [
          {
            "name": "Anthony Davidson",
            "rating": 48,
            "races": 4
          },
          {
            "name": "Takuma Sato",
            "rating": 63,
            "races": 4
          }
        ],
        "points": 0.0,
        "standingPosition": 11
      }
    ],
    "2016": [
      {
        "id": "ferrari",
        "team": "Ferrari",
        "rating": 99,
        "races": 21,
        "drivers": [
          {
            "name": "Kimi Räikkönen",
            "rating": 99,
            "races": 21
          },
          {
            "name": "Sebastian Vettel",
            "rating": 99,
            "races": 21
          }
        ],
        "points": 398.0,
        "standingPosition": 3
      },
      {
        "id": "force-india",
        "team": "Force India",
        "rating": 63,
        "races": 21,
        "drivers": [
          {
            "name": "Nico Hülkenberg",
            "rating": 53,
            "races": 21
          },
          {
            "name": "Sergio Pérez",
            "rating": 79,
            "races": 21
          }
        ],
        "points": 173.0,
        "standingPosition": 4
      },
      {
        "id": "haas-f1-team",
        "team": "Haas F1 Team",
        "rating": 50,
        "races": 21,
        "drivers": [
          {
            "name": "Esteban Gutiérrez",
            "rating": 53,
            "races": 21
          },
          {
            "name": "Romain Grosjean",
            "rating": 69,
            "races": 21
          }
        ],
        "points": 29.0,
        "standingPosition": 8
      },
      {
        "id": "manor-marussia",
        "team": "Manor Marussia",
        "rating": 47,
        "races": 21,
        "drivers": [
          {
            "name": "Pascal Wehrlein",
            "rating": 51,
            "races": 21
          },
          {
            "name": "Rio Haryanto",
            "rating": 53,
            "races": 12
          },
          {
            "name": "Esteban Ocon",
            "rating": 55,
            "races": 9
          }
        ],
        "points": 1.0,
        "standingPosition": 11
      },
      {
        "id": "mclaren",
        "team": "McLaren",
        "rating": 99,
        "races": 21,
        "drivers": [
          {
            "name": "Jenson Button",
            "rating": 93,
            "races": 21
          },
          {
            "name": "Fernando Alonso",
            "rating": 99,
            "races": 20
          },
          {
            "name": "Stoffel Vandoorne",
            "rating": 46,
            "races": 1
          }
        ],
        "points": 76.0,
        "standingPosition": 6
      },
      {
        "id": "mercedes",
        "team": "Mercedes",
        "rating": 99,
        "races": 21,
        "drivers": [
          {
            "name": "Lewis Hamilton",
            "rating": 99,
            "races": 21
          },
          {
            "name": "Nico Rosberg",
            "rating": 93,
            "races": 21
          }
        ],
        "points": 765.0,
        "standingPosition": 1
      },
      {
        "id": "red-bull",
        "team": "Red Bull",
        "rating": 99,
        "races": 21,
        "drivers": [
          {
            "name": "Daniel Ricciardo",
            "rating": 70,
            "races": 21
          },
          {
            "name": "Max Verstappen",
            "rating": 99,
            "races": 17
          },
          {
            "name": "Daniil Kvyat",
            "rating": 56,
            "races": 4
          }
        ],
        "points": 468.0,
        "standingPosition": 2
      },
      {
        "id": "renault",
        "team": "Renault",
        "rating": 99,
        "races": 21,
        "drivers": [
          {
            "name": "Jolyon Palmer",
            "rating": 47,
            "races": 21
          },
          {
            "name": "Kevin Magnussen",
            "rating": 60,
            "races": 21
          }
        ],
        "points": 8.0,
        "standingPosition": 9
      },
      {
        "id": "sauber",
        "team": "Sauber",
        "rating": 63,
        "races": 21,
        "drivers": [
          {
            "name": "Felipe Nasr",
            "rating": 49,
            "races": 21
          },
          {
            "name": "Marcus Ericsson",
            "rating": 53,
            "races": 21
          }
        ],
        "points": 2.0,
        "standingPosition": 10
      },
      {
        "id": "toro-rosso",
        "team": "Toro Rosso",
        "rating": 51,
        "races": 21,
        "drivers": [
          {
            "name": "Carlos Sainz",
            "rating": 74,
            "races": 21
          },
          {
            "name": "Daniil Kvyat",
            "rating": 56,
            "races": 17
          },
          {
            "name": "Max Verstappen",
            "rating": 99,
            "races": 4
          }
        ],
        "points": 63.0,
        "standingPosition": 7
      },
      {
        "id": "williams",
        "team": "Williams",
        "rating": 99,
        "races": 21,
        "drivers": [
          {
            "name": "Felipe Massa",
            "rating": 80,
            "races": 21
          },
          {
            "name": "Valtteri Bottas",
            "rating": 86,
            "races": 21
          }
        ],
        "points": 138.0,
        "standingPosition": 5
      }
    ],
    "2024": [
      {
        "id": "alpine-f1-team",
        "team": "Alpine F1 Team",
        "rating": 64,
        "races": 24,
        "drivers": [
          {
            "name": "Pierre Gasly",
            "rating": 60,
            "races": 24
          },
          {
            "name": "Esteban Ocon",
            "rating": 55,
            "races": 23
          },
          {
            "name": "Jack Doohan",
            "rating": 52,
            "races": 1
          }
        ],
        "points": 65.0,
        "standingPosition": 6
      },
      {
        "id": "aston-martin",
        "team": "Aston Martin",
        "rating": 54,
        "races": 24,
        "drivers": [
          {
            "name": "Fernando Alonso",
            "rating": 99,
            "races": 24
          },
          {
            "name": "Lance Stroll",
            "rating": 66,
            "races": 24
          }
        ],
        "points": 94.0,
        "standingPosition": 5
      },
      {
        "id": "ferrari",
        "team": "Ferrari",
        "rating": 99,
        "races": 24,
        "drivers": [
          {
            "name": "Charles Leclerc",
            "rating": 75,
            "races": 24
          },
          {
            "name": "Carlos Sainz",
            "rating": 74,
            "races": 23
          },
          {
            "name": "Oliver Bearman",
            "rating": 48,
            "races": 1
          }
        ],
        "points": 652.0,
        "standingPosition": 2
      },
      {
        "id": "haas-f1-team",
        "team": "Haas F1 Team",
        "rating": 50,
        "races": 24,
        "drivers": [
          {
            "name": "Nico Hülkenberg",
            "rating": 53,
            "races": 24
          },
          {
            "name": "Kevin Magnussen",
            "rating": 60,
            "races": 22
          },
          {
            "name": "Oliver Bearman",
            "rating": 48,
            "races": 2
          }
        ],
        "points": 58.0,
        "standingPosition": 7
      },
      {
        "id": "mclaren",
        "team": "McLaren",
        "rating": 99,
        "races": 24,
        "drivers": [
          {
            "name": "Lando Norris",
            "rating": 64,
            "races": 24
          },
          {
            "name": "Oscar Piastri",
            "rating": 57,
            "races": 24
          }
        ],
        "points": 666.0,
        "standingPosition": 1
      },
      {
        "id": "mercedes",
        "team": "Mercedes",
        "rating": 99,
        "races": 24,
        "drivers": [
          {
            "name": "George Russell",
            "rating": 59,
            "races": 24
          },
          {
            "name": "Lewis Hamilton",
            "rating": 99,
            "races": 24
          }
        ],
        "points": 468.0,
        "standingPosition": 4
      },
      {
        "id": "rb-f1-team",
        "team": "RB F1 Team",
        "rating": 55,
        "races": 24,
        "drivers": [
          {
            "name": "Yuki Tsunoda",
            "rating": 61,
            "races": 24
          },
          {
            "name": "Daniel Ricciardo",
            "rating": 70,
            "races": 18
          },
          {
            "name": "Liam Lawson",
            "rating": 50,
            "races": 6
          }
        ],
        "points": 46.0,
        "standingPosition": 8
      },
      {
        "id": "red-bull",
        "team": "Red Bull",
        "rating": 99,
        "races": 24,
        "drivers": [
          {
            "name": "Max Verstappen",
            "rating": 99,
            "races": 24
          },
          {
            "name": "Sergio Pérez",
            "rating": 79,
            "races": 24
          }
        ],
        "points": 589.0,
        "standingPosition": 3
      },
      {
        "id": "sauber",
        "team": "Sauber",
        "rating": 63,
        "races": 24,
        "drivers": [
          {
            "name": "Guanyu Zhou",
            "rating": 54,
            "races": 24
          },
          {
            "name": "Valtteri Bottas",
            "rating": 86,
            "races": 24
          }
        ],
        "points": 4.0,
        "standingPosition": 10
      },
      {
        "id": "williams",
        "team": "Williams",
        "rating": 99,
        "races": 24,
        "drivers": [
          {
            "name": "Alexander Albon",
            "rating": 52,
            "races": 24
          },
          {
            "name": "Logan Sargeant",
            "rating": 54,
            "races": 14
          },
          {
            "name": "Franco Colapinto",
            "rating": 52,
            "races": 9
          }
        ],
        "points": 17.0,
        "standingPosition": 9
      }
    ]
  },
  "constructorStandingsByYear": {
    "1955": [],
    "1965": [
      {
        "team": "Lotus-Climax",
        "position": 1,
        "points": 54.0
      },
      {
        "team": "BRM",
        "position": 2,
        "points": 45.0
      },
      {
        "team": "Brabham-Climax",
        "position": 3,
        "points": 27.0
      },
      {
        "team": "Ferrari",
        "position": 4,
        "points": 26.0
      },
      {
        "team": "Cooper-Climax",
        "position": 5,
        "points": 14.0
      },
      {
        "team": "Honda",
        "position": 6,
        "points": 11.0
      },
      {
        "team": "Brabham-BRM",
        "position": 7,
        "points": 5.0
      },
      {
        "team": "Lotus-BRM",
        "position": 8,
        "points": 2.0
      },
      {
        "team": "Brabham-Ford",
        "position": 9,
        "points": 0.0
      },
      {
        "team": "Alfa Romeo",
        "position": 10,
        "points": 0.0
      },
      {
        "team": "LDS-Alfa Romeo",
        "position": 11,
        "points": 0.0
      },
      {
        "team": "Cooper-Ford",
        "position": 12,
        "points": 0.0
      },
      {
        "team": "LDS-Climax",
        "position": 13,
        "points": 0.0
      },
      {
        "team": "Lotus-Ford",
        "position": 14,
        "points": 0.0
      },
      {
        "team": "RE",
        "position": 15,
        "points": 0.0
      },
      {
        "team": "Cooper-Maserati",
        "position": 16,
        "points": 0.0
      }
    ],
    "1976": [
      {
        "team": "Ferrari",
        "position": 1,
        "points": 83.0
      },
      {
        "team": "McLaren",
        "position": 2,
        "points": 74.0
      },
      {
        "team": "Tyrrell",
        "position": 3,
        "points": 71.0
      },
      {
        "team": "Team Lotus",
        "position": 4,
        "points": 29.0
      },
      {
        "team": "Penske",
        "position": 5,
        "points": 20.0
      },
      {
        "team": "Ligier",
        "position": 6,
        "points": 20.0
      },
      {
        "team": "March",
        "position": 7,
        "points": 19.0
      },
      {
        "team": "Shadow",
        "position": 8,
        "points": 10.0
      },
      {
        "team": "Brabham-Alfa Romeo",
        "position": 9,
        "points": 9.0
      },
      {
        "team": "Surtees",
        "position": 10,
        "points": 7.0
      },
      {
        "team": "Fittipaldi",
        "position": 11,
        "points": 3.0
      },
      {
        "team": "Ensign",
        "position": 12,
        "points": 2.0
      },
      {
        "team": "Parnelli",
        "position": 13,
        "points": 1.0
      },
      {
        "team": "Hesketh",
        "position": 14,
        "points": 0.0
      },
      {
        "team": "Wolf",
        "position": 15,
        "points": 0.0
      },
      {
        "team": "Boro",
        "position": 16,
        "points": 0.0
      },
      {
        "team": "Williams",
        "position": 17,
        "points": 0.0
      },
      {
        "team": "Kojima",
        "position": 18,
        "points": 0.0
      },
      {
        "team": "Brabham-Ford",
        "position": 19,
        "points": 0.0
      },
      {
        "team": "BRM",
        "position": 20,
        "points": 0.0
      },
      {
        "team": "Maki",
        "position": 21,
        "points": 0.0
      }
    ],
    "1988": [
      {
        "team": "McLaren",
        "position": 1,
        "points": 199.0
      },
      {
        "team": "Ferrari",
        "position": 2,
        "points": 65.0
      },
      {
        "team": "Benetton",
        "position": 3,
        "points": 39.0
      },
      {
        "team": "Team Lotus",
        "position": 4,
        "points": 23.0
      },
      {
        "team": "Arrows",
        "position": 5,
        "points": 23.0
      },
      {
        "team": "March",
        "position": 6,
        "points": 22.0
      },
      {
        "team": "Williams",
        "position": 7,
        "points": 20.0
      },
      {
        "team": "Tyrrell",
        "position": 8,
        "points": 5.0
      },
      {
        "team": "Rial",
        "position": 9,
        "points": 3.0
      },
      {
        "team": "Minardi",
        "position": 10,
        "points": 1.0
      },
      {
        "team": "Larrousse",
        "position": 11,
        "points": 0.0
      },
      {
        "team": "Dallara",
        "position": 12,
        "points": 0.0
      },
      {
        "team": "AGS",
        "position": 13,
        "points": 0.0
      },
      {
        "team": "Coloni",
        "position": 14,
        "points": 0.0
      },
      {
        "team": "Ligier",
        "position": 15,
        "points": 0.0
      },
      {
        "team": "Osella",
        "position": 16,
        "points": 0.0
      },
      {
        "team": "Euro Brun",
        "position": 17,
        "points": 0.0
      },
      {
        "team": "Zakspeed",
        "position": 18,
        "points": 0.0
      }
    ],
    "1998": [
      {
        "team": "McLaren",
        "position": 1,
        "points": 156.0
      },
      {
        "team": "Ferrari",
        "position": 2,
        "points": 133.0
      },
      {
        "team": "Williams",
        "position": 3,
        "points": 38.0
      },
      {
        "team": "Jordan",
        "position": 4,
        "points": 34.0
      },
      {
        "team": "Benetton",
        "position": 5,
        "points": 33.0
      },
      {
        "team": "Sauber",
        "position": 6,
        "points": 10.0
      },
      {
        "team": "Arrows",
        "position": 7,
        "points": 6.0
      },
      {
        "team": "Stewart",
        "position": 8,
        "points": 5.0
      },
      {
        "team": "Prost",
        "position": 9,
        "points": 1.0
      },
      {
        "team": "Minardi",
        "position": 10,
        "points": 0.0
      },
      {
        "team": "Tyrrell",
        "position": 11,
        "points": 0.0
      }
    ],
    "2008": [
      {
        "team": "Ferrari",
        "position": 1,
        "points": 172.0
      },
      {
        "team": "McLaren",
        "position": 2,
        "points": 151.0
      },
      {
        "team": "BMW Sauber",
        "position": 3,
        "points": 135.0
      },
      {
        "team": "Renault",
        "position": 4,
        "points": 80.0
      },
      {
        "team": "Toyota",
        "position": 5,
        "points": 56.0
      },
      {
        "team": "Toro Rosso",
        "position": 6,
        "points": 39.0
      },
      {
        "team": "Red Bull",
        "position": 7,
        "points": 29.0
      },
      {
        "team": "Williams",
        "position": 8,
        "points": 26.0
      },
      {
        "team": "Honda",
        "position": 9,
        "points": 14.0
      },
      {
        "team": "Force India",
        "position": 10,
        "points": 0.0
      },
      {
        "team": "Super Aguri",
        "position": 11,
        "points": 0.0
      }
    ],
    "2016": [
      {
        "team": "Mercedes",
        "position": 1,
        "points": 765.0
      },
      {
        "team": "Red Bull",
        "position": 2,
        "points": 468.0
      },
      {
        "team": "Ferrari",
        "position": 3,
        "points": 398.0
      },
      {
        "team": "Force India",
        "position": 4,
        "points": 173.0
      },
      {
        "team": "Williams",
        "position": 5,
        "points": 138.0
      },
      {
        "team": "McLaren",
        "position": 6,
        "points": 76.0
      },
      {
        "team": "Toro Rosso",
        "position": 7,
        "points": 63.0
      },
      {
        "team": "Haas F1 Team",
        "position": 8,
        "points": 29.0
      },
      {
        "team": "Renault",
        "position": 9,
        "points": 8.0
      },
      {
        "team": "Sauber",
        "position": 10,
        "points": 2.0
      },
      {
        "team": "Manor Marussia",
        "position": 11,
        "points": 1.0
      }
    ],
    "2024": [
      {
        "team": "McLaren",
        "position": 1,
        "points": 666.0
      },
      {
        "team": "Ferrari",
        "position": 2,
        "points": 652.0
      },
      {
        "team": "Red Bull",
        "position": 3,
        "points": 589.0
      },
      {
        "team": "Mercedes",
        "position": 4,
        "points": 468.0
      },
      {
        "team": "Aston Martin",
        "position": 5,
        "points": 94.0
      },
      {
        "team": "Alpine F1 Team",
        "position": 6,
        "points": 65.0
      },
      {
        "team": "Haas F1 Team",
        "position": 7,
        "points": 58.0
      },
      {
        "team": "RB F1 Team",
        "position": 8,
        "points": 46.0
      },
      {
        "team": "Williams",
        "position": 9,
        "points": 17.0
      },
      {
        "team": "Sauber",
        "position": 10,
        "points": 4.0
      }
    ]
  },
  "championsByYear": {
    "2008": "Lewis Hamilton",
    "2007": "Kimi Räikkönen",
    "2006": "Fernando Alonso",
    "2005": "Fernando Alonso",
    "2004": "Michael Schumacher",
    "2003": "Michael Schumacher",
    "2002": "Michael Schumacher",
    "2001": "Michael Schumacher",
    "2000": "Michael Schumacher",
    "1999": "Mika Häkkinen",
    "1998": "Mika Häkkinen",
    "1997": "Jacques Villeneuve",
    "1996": "Damon Hill",
    "1995": "Michael Schumacher",
    "1994": "Michael Schumacher",
    "1993": "Alain Prost",
    "1992": "Nigel Mansell",
    "1990": "Ayrton Senna",
    "1991": "Ayrton Senna",
    "1989": "Alain Prost",
    "1988": "Ayrton Senna",
    "1987": "Nelson Piquet",
    "1986": "Alain Prost",
    "1985": "Alain Prost",
    "1984": "Niki Lauda",
    "1983": "Nelson Piquet",
    "1982": "Keke Rosberg",
    "1981": "Nelson Piquet",
    "1980": "Alan Jones",
    "1979": "Jody Scheckter",
    "1978": "Mario Andretti",
    "1977": "Niki Lauda",
    "1976": "James Hunt",
    "1975": "Niki Lauda",
    "1974": "Emerson Fittipaldi",
    "1973": "Jackie Stewart",
    "1972": "Emerson Fittipaldi",
    "1971": "Jackie Stewart",
    "2009": "Jenson Button",
    "1970": "Jochen Rindt",
    "1969": "Jackie Stewart",
    "1968": "Graham Hill",
    "1967": "Denny Hulme",
    "1966": "Jack Brabham",
    "1965": "Jim Clark",
    "1964": "John Surtees",
    "1962": "Graham Hill",
    "1961": "Phil Hill",
    "1960": "Jack Brabham",
    "1958": "Mike Hawthorn",
    "1957": "Juan Fangio",
    "1956": "Juan Fangio",
    "1955": "Juan Fangio",
    "1953": "Alberto Ascari",
    "1952": "Alberto Ascari",
    "1951": "Juan Fangio",
    "1950": "Nino Farina",
    "1954": "Juan Fangio",
    "1963": "Jim Clark",
    "1959": "Jack Brabham",
    "2010": "Sebastian Vettel",
    "2011": "Sebastian Vettel",
    "2012": "Sebastian Vettel",
    "2013": "Sebastian Vettel",
    "2014": "Lewis Hamilton",
    "2015": "Lewis Hamilton",
    "2016": "Nico Rosberg",
    "2017": "Lewis Hamilton",
    "2018": "Lewis Hamilton",
    "2019": "Lewis Hamilton",
    "2020": "Lewis Hamilton",
    "2021": "Max Verstappen",
    "2022": "Max Verstappen",
    "2023": "Max Verstappen",
    "2024": "Max Verstappen"
  },
  "winsBySeason": {
    "Jenson Button": {
      "2009": 6,
      "2006": 1,
      "2010": 2,
      "2011": 3,
      "2012": 3
    },
    "Sebastian Vettel": {
      "2009": 4,
      "2008": 1,
      "2010": 5,
      "2011": 11,
      "2012": 5,
      "2013": 13,
      "2015": 3,
      "2017": 5,
      "2018": 5,
      "2019": 1
    },
    "Mark Webber": {
      "2009": 2,
      "2010": 4,
      "2011": 1,
      "2012": 2
    },
    "Lewis Hamilton": {
      "2009": 2,
      "2008": 5,
      "2007": 4,
      "2010": 3,
      "2011": 3,
      "2012": 4,
      "2013": 1,
      "2014": 11,
      "2015": 10,
      "2016": 10,
      "2017": 9,
      "2018": 11,
      "2019": 11,
      "2020": 11,
      "2021": 8,
      "2024": 2
    },
    "Rubens Barrichello": {
      "2009": 2,
      "2004": 2,
      "2003": 2,
      "2002": 4,
      "2000": 1
    },
    "Kimi Räikkönen": {
      "2009": 1,
      "2008": 2,
      "2007": 6,
      "2005": 7,
      "2004": 1,
      "2003": 1,
      "2012": 1,
      "2013": 1,
      "2018": 1
    },
    "Felipe Massa": {
      "2008": 6,
      "2007": 3,
      "2006": 2
    },
    "Robert Kubica": {
      "2008": 1
    },
    "Heikki Kovalainen": {
      "2008": 1
    },
    "Fernando Alonso": {
      "2008": 2,
      "2007": 4,
      "2006": 7,
      "2005": 7,
      "2003": 1,
      "2010": 5,
      "2011": 1,
      "2012": 3,
      "2013": 2
    },
    "Giancarlo Fisichella": {
      "2006": 1,
      "2005": 1,
      "2003": 1
    },
    "Michael Schumacher": {
      "2006": 7,
      "2005": 1,
      "2004": 13,
      "2003": 6,
      "2002": 11,
      "2001": 9,
      "2000": 9,
      "1999": 2,
      "1998": 6,
      "1997": 5,
      "1996": 3,
      "1995": 9,
      "1994": 8,
      "1993": 1,
      "1992": 1
    },
    "Jarno Trulli": {
      "2004": 1
    },
    "David Coulthard": {
      "2003": 1,
      "2002": 1,
      "2001": 2,
      "2000": 3,
      "1999": 2,
      "1998": 1,
      "1997": 2,
      "1995": 1
    },
    "Ralf Schumacher": {
      "2003": 2,
      "2002": 1,
      "2001": 3
    },
    "Mika Häkkinen": {
      "2001": 2,
      "2000": 4,
      "1999": 5,
      "1998": 8,
      "1997": 1
    },
    "Eddie Irvine": {
      "1999": 4
    },
    "Heinz-Harald Frentzen": {
      "1999": 2,
      "1997": 1
    },
    "Johnny Herbert": {
      "1999": 1,
      "1995": 2
    },
    "Damon Hill": {
      "1998": 1,
      "1996": 8,
      "1995": 4,
      "1994": 6,
      "1993": 3
    },
    "Jacques Villeneuve": {
      "1997": 7,
      "1996": 4
    },
    "Gerhard Berger": {
      "1997": 1,
      "1994": 1,
      "1992": 2,
      "1991": 1,
      "1989": 1,
      "1988": 1,
      "1987": 2,
      "1986": 1
    },
    "Olivier Panis": {
      "1996": 1
    },
    "Jean Alesi": {
      "1995": 1
    },
    "Nigel Mansell": {
      "1994": 1,
      "1992": 9,
      "1991": 5,
      "1990": 1,
      "1989": 2,
      "1987": 6,
      "1986": 5,
      "1985": 2
    },
    "Alain Prost": {
      "1993": 7,
      "1990": 5,
      "1989": 4,
      "1988": 7,
      "1987": 3,
      "1986": 4,
      "1985": 5,
      "1984": 7,
      "1983": 4,
      "1982": 2,
      "1981": 3
    },
    "Ayrton Senna": {
      "1993": 5,
      "1992": 3,
      "1991": 7,
      "1990": 6,
      "1989": 6,
      "1988": 8,
      "1987": 2,
      "1986": 2,
      "1985": 2
    },
    "Riccardo Patrese": {
      "1992": 1,
      "1991": 2,
      "1990": 1,
      "1983": 1,
      "1982": 1
    },
    "Nelson Piquet": {
      "1991": 1,
      "1990": 2,
      "1987": 3,
      "1986": 4,
      "1985": 1,
      "1984": 2,
      "1983": 3,
      "1982": 1,
      "1981": 3,
      "1980": 3
    },
    "Thierry Boutsen": {
      "1990": 1,
      "1989": 2
    },
    "Alessandro Nannini": {
      "1989": 1
    },
    "Michele Alboreto": {
      "1985": 2,
      "1984": 1,
      "1983": 1,
      "1982": 1
    },
    "Niki Lauda": {
      "1985": 1,
      "1984": 5,
      "1982": 2,
      "1978": 2,
      "1977": 3,
      "1976": 5,
      "1975": 5,
      "1974": 2
    },
    "John Watson": {
      "1983": 1,
      "1982": 2,
      "1981": 1,
      "1976": 1
    },
    "René Arnoux": {
      "1983": 3,
      "1982": 2,
      "1980": 2
    },
    "Alan Jones": {
      "1981": 2,
      "1980": 5,
      "1979": 4,
      "1977": 1
    },
    "Carlos Reutemann": {
      "1981": 2,
      "1980": 1,
      "1978": 4,
      "1977": 1,
      "1975": 1,
      "1974": 3
    },
    "Jacques Laffite": {
      "1981": 2,
      "1980": 1,
      "1979": 2,
      "1977": 1
    },
    "Patrick Depailler": {
      "1979": 1,
      "1978": 1
    },
    "Jody Scheckter": {
      "1979": 3,
      "1977": 3,
      "1976": 1,
      "1975": 1,
      "1974": 2
    },
    "Clay Regazzoni": {
      "1979": 1,
      "1976": 1,
      "1975": 1,
      "1974": 1,
      "1970": 1
    },
    "Mario Andretti": {
      "1978": 6,
      "1977": 4,
      "1976": 1,
      "1971": 1
    },
    "Ronnie Peterson": {
      "1978": 2,
      "1976": 1,
      "1974": 3,
      "1973": 4
    },
    "Gunnar Nilsson": {
      "1977": 1
    },
    "James Hunt": {
      "1977": 3,
      "1976": 6,
      "1975": 1
    },
    "Emerson Fittipaldi": {
      "1975": 2,
      "1974": 3,
      "1973": 3,
      "1972": 5,
      "1970": 1
    },
    "Carlos Pace": {
      "1975": 1
    },
    "Jochen Mass": {
      "1975": 1
    },
    "Vittorio Brambilla": {
      "1975": 1
    },
    "Jackie Stewart": {
      "1973": 5,
      "1972": 4,
      "1971": 6,
      "1970": 1,
      "1969": 6,
      "1968": 3,
      "1966": 1,
      "1965": 1
    },
    "Jacky Ickx": {
      "1972": 1,
      "1971": 1,
      "1970": 3,
      "1969": 2,
      "1968": 1
    },
    "Jo Siffert": {
      "1971": 1,
      "1968": 1
    },
    "Jack Brabham": {
      "1970": 1,
      "1967": 2,
      "1966": 4,
      "1960": 5,
      "1959": 2
    },
    "Jochen Rindt": {
      "1970": 5,
      "1969": 1
    },
    "Pedro Rodríguez": {
      "1970": 1,
      "1967": 1
    },
    "Graham Hill": {
      "1969": 1,
      "1968": 3,
      "1965": 2,
      "1964": 2,
      "1963": 2,
      "1962": 4
    },
    "Jim Clark": {
      "1968": 1,
      "1967": 4,
      "1966": 1,
      "1965": 6,
      "1964": 3,
      "1963": 7,
      "1962": 3
    },
    "Bruce McLaren": {
      "1968": 1,
      "1962": 1,
      "1960": 1,
      "1959": 1
    },
    "Dan Gurney": {
      "1967": 1,
      "1964": 2,
      "1962": 1
    },
    "John Surtees": {
      "1967": 1,
      "1966": 2,
      "1964": 2,
      "1963": 1
    },
    "Richie Ginther": {
      "1965": 1
    },
    "Lorenzo Bandini": {
      "1964": 1
    },
    "Stirling Moss": {
      "1961": 2,
      "1960": 2,
      "1959": 2,
      "1958": 4,
      "1957": 3,
      "1956": 2,
      "1955": 1
    },
    "Innes Ireland": {
      "1961": 1
    },
    "Jim Rathmann": {
      "1960": 1
    },
    "Jo Bonnier": {
      "1959": 1
    },
    "Maurice Trintignant": {
      "1958": 1,
      "1955": 1
    },
    "Jimmy Bryan": {
      "1958": 1
    },
    "Mike Hawthorn": {
      "1958": 1,
      "1954": 1,
      "1953": 1
    },
    "Juan Fangio": {
      "1957": 4,
      "1956": 3,
      "1955": 4,
      "1954": 6,
      "1953": 1,
      "1951": 3,
      "1950": 3
    },
    "Luigi Musso": {
      "1956": 1
    },
    "Alberto Ascari": {
      "1953": 5,
      "1952": 6,
      "1951": 2
    },
    "Nino Farina": {
      "1953": 1,
      "1951": 1,
      "1950": 3
    },
    "Nico Rosberg": {
      "2012": 1,
      "2013": 2,
      "2014": 5,
      "2015": 6,
      "2016": 9
    },
    "Daniel Ricciardo": {
      "2014": 3,
      "2016": 1,
      "2017": 1,
      "2018": 2,
      "2021": 1
    },
    "Max Verstappen": {
      "2016": 1,
      "2017": 2,
      "2018": 2,
      "2019": 3,
      "2020": 2,
      "2021": 10,
      "2022": 15,
      "2023": 19,
      "2024": 9
    },
    "Valtteri Bottas": {
      "2017": 3,
      "2019": 4,
      "2020": 2,
      "2021": 1
    },
    "Charles Leclerc": {
      "2019": 2,
      "2022": 3,
      "2024": 3
    },
    "Pierre Gasly": {
      "2020": 1
    },
    "Sergio Pérez": {
      "2020": 1,
      "2021": 1,
      "2022": 2,
      "2023": 2
    },
    "Esteban Ocon": {
      "2021": 1
    },
    "Carlos Sainz": {
      "2022": 1,
      "2023": 1,
      "2024": 2
    },
    "George Russell": {
      "2022": 1,
      "2024": 2
    },
    "Lando Norris": {
      "2024": 4
    },
    "Oscar Piastri": {
      "2024": 2
    }
  },
  "podiumsBySeason": {
    "Jenson Button": {
      "2009": 9,
      "2006": 3,
      "2010": 7,
      "2011": 12,
      "2012": 6,
      "2004": 10,
      "2005": 2,
      "2014": 1
    },
    "Sebastian Vettel": {
      "2009": 8,
      "2008": 1,
      "2010": 10,
      "2011": 17,
      "2012": 10,
      "2013": 16,
      "2015": 13,
      "2017": 13,
      "2018": 12,
      "2019": 9,
      "2014": 4,
      "2016": 7,
      "2021": 1,
      "2020": 1
    },
    "Mark Webber": {
      "2009": 8,
      "2010": 10,
      "2011": 10,
      "2012": 4,
      "2013": 8,
      "2007": 1,
      "2005": 1
    },
    "Lewis Hamilton": {
      "2009": 5,
      "2008": 10,
      "2007": 12,
      "2010": 9,
      "2011": 6,
      "2012": 7,
      "2013": 5,
      "2014": 16,
      "2015": 17,
      "2016": 17,
      "2017": 13,
      "2018": 17,
      "2019": 17,
      "2020": 14,
      "2021": 17,
      "2024": 5,
      "2022": 9,
      "2023": 6
    },
    "Rubens Barrichello": {
      "2009": 6,
      "2004": 14,
      "2003": 8,
      "2002": 10,
      "2000": 9,
      "2005": 4,
      "2001": 10,
      "1997": 1,
      "1995": 1,
      "2008": 1,
      "1999": 3,
      "1994": 1
    },
    "Kimi Räikkönen": {
      "2009": 5,
      "2008": 9,
      "2007": 12,
      "2005": 12,
      "2004": 4,
      "2003": 10,
      "2012": 7,
      "2013": 8,
      "2018": 12,
      "2006": 6,
      "2002": 4,
      "2015": 3,
      "2016": 4,
      "2017": 7
    },
    "Felipe Massa": {
      "2008": 10,
      "2007": 10,
      "2006": 7,
      "2010": 5,
      "2012": 2,
      "2014": 3,
      "2009": 1,
      "2013": 1,
      "2015": 2
    },
    "Robert Kubica": {
      "2008": 7,
      "2009": 1,
      "2010": 3,
      "2006": 1
    },
    "Heikki Kovalainen": {
      "2008": 3,
      "2007": 1
    },
    "Fernando Alonso": {
      "2008": 3,
      "2007": 12,
      "2006": 14,
      "2005": 15,
      "2003": 4,
      "2010": 10,
      "2011": 10,
      "2012": 13,
      "2013": 9,
      "2004": 4,
      "2014": 2,
      "2023": 8,
      "2009": 1,
      "2021": 1
    },
    "Giancarlo Fisichella": {
      "2006": 5,
      "2005": 3,
      "2003": 1,
      "2009": 1,
      "2000": 3,
      "1999": 1,
      "1998": 2,
      "1997": 2,
      "2001": 1
    },
    "Michael Schumacher": {
      "2006": 12,
      "2005": 5,
      "2004": 15,
      "2003": 8,
      "2002": 17,
      "2001": 14,
      "2000": 12,
      "1999": 6,
      "1998": 11,
      "1997": 8,
      "1996": 8,
      "1995": 11,
      "1994": 10,
      "1993": 9,
      "1992": 8,
      "2012": 1
    },
    "Jarno Trulli": {
      "2004": 2,
      "2009": 3,
      "2005": 3,
      "1999": 1,
      "2008": 1,
      "2003": 1
    },
    "David Coulthard": {
      "2003": 3,
      "2002": 6,
      "2001": 10,
      "2000": 11,
      "1999": 6,
      "1998": 9,
      "1997": 4,
      "1995": 8,
      "1996": 2,
      "1994": 1,
      "2008": 1,
      "2006": 1
    },
    "Ralf Schumacher": {
      "2003": 3,
      "2002": 6,
      "2001": 5,
      "2004": 1,
      "1999": 3,
      "1998": 2,
      "2006": 1,
      "2005": 2,
      "2000": 3,
      "1997": 1
    },
    "Mika Häkkinen": {
      "2001": 3,
      "2000": 11,
      "1999": 10,
      "1998": 11,
      "1997": 3,
      "1995": 2,
      "1994": 6,
      "1996": 4,
      "1993": 1
    },
    "Eddie Irvine": {
      "1999": 9,
      "1998": 8,
      "1997": 5,
      "2002": 1,
      "2001": 1,
      "1996": 1,
      "1995": 1
    },
    "Heinz-Harald Frentzen": {
      "1999": 6,
      "1997": 7,
      "2003": 1,
      "2000": 2,
      "1998": 1,
      "1995": 1
    },
    "Johnny Herbert": {
      "1999": 1,
      "1995": 4,
      "1997": 1,
      "1996": 1
    },
    "Damon Hill": {
      "1998": 1,
      "1996": 10,
      "1995": 9,
      "1994": 11,
      "1993": 10,
      "1997": 1
    },
    "Jacques Villeneuve": {
      "1997": 8,
      "1996": 11,
      "2001": 2,
      "1998": 2
    },
    "Gerhard Berger": {
      "1997": 2,
      "1994": 6,
      "1992": 5,
      "1991": 6,
      "1989": 3,
      "1988": 5,
      "1987": 3,
      "1986": 2,
      "1996": 2,
      "1990": 7,
      "1995": 6,
      "1993": 1
    },
    "Olivier Panis": {
      "1996": 1,
      "1997": 2,
      "1995": 1,
      "1994": 1
    },
    "Jean Alesi": {
      "1995": 5,
      "1997": 5,
      "1996": 8,
      "1994": 4,
      "1993": 2,
      "1990": 2,
      "1998": 1,
      "1992": 2,
      "1991": 3
    },
    "Nigel Mansell": {
      "1994": 1,
      "1992": 12,
      "1991": 9,
      "1990": 5,
      "1989": 6,
      "1987": 7,
      "1986": 9,
      "1985": 3,
      "1988": 2,
      "1984": 2,
      "1983": 1,
      "1982": 1,
      "1981": 1
    },
    "Alain Prost": {
      "1993": 12,
      "1990": 9,
      "1989": 11,
      "1988": 14,
      "1987": 7,
      "1986": 11,
      "1985": 11,
      "1984": 9,
      "1983": 7,
      "1982": 4,
      "1981": 6,
      "1991": 5
    },
    "Ayrton Senna": {
      "1993": 7,
      "1992": 7,
      "1991": 12,
      "1990": 11,
      "1989": 7,
      "1988": 11,
      "1987": 8,
      "1986": 8,
      "1985": 6,
      "1984": 3
    },
    "Riccardo Patrese": {
      "1992": 9,
      "1991": 8,
      "1990": 1,
      "1983": 2,
      "1982": 3,
      "1993": 2,
      "1989": 6,
      "1981": 2,
      "1980": 1,
      "1978": 1,
      "1987": 1,
      "1984": 1
    },
    "Nelson Piquet": {
      "1991": 3,
      "1990": 4,
      "1987": 11,
      "1986": 10,
      "1985": 2,
      "1984": 4,
      "1983": 8,
      "1982": 2,
      "1981": 7,
      "1980": 6,
      "1988": 3
    },
    "Thierry Boutsen": {
      "1990": 3,
      "1989": 5,
      "1985": 1,
      "1988": 5,
      "1987": 1
    },
    "Alessandro Nannini": {
      "1989": 4,
      "1990": 3,
      "1988": 2
    },
    "Michele Alboreto": {
      "1985": 8,
      "1984": 4,
      "1983": 1,
      "1982": 2,
      "1988": 3,
      "1987": 3,
      "1986": 1,
      "1989": 1
    },
    "Niki Lauda": {
      "1985": 1,
      "1984": 9,
      "1982": 3,
      "1978": 7,
      "1977": 10,
      "1976": 9,
      "1975": 8,
      "1974": 5,
      "1983": 2
    },
    "John Watson": {
      "1983": 3,
      "1982": 5,
      "1981": 4,
      "1976": 3,
      "1978": 3,
      "1977": 1,
      "1979": 1
    },
    "René Arnoux": {
      "1983": 7,
      "1982": 4,
      "1980": 3,
      "1984": 4,
      "1981": 1,
      "1979": 3
    },
    "Alan Jones": {
      "1981": 6,
      "1980": 10,
      "1979": 5,
      "1977": 2,
      "1978": 1
    },
    "Carlos Reutemann": {
      "1981": 7,
      "1980": 8,
      "1978": 7,
      "1977": 6,
      "1975": 6,
      "1974": 4,
      "1982": 1,
      "1979": 4,
      "1973": 2
    },
    "Jacques Laffite": {
      "1981": 7,
      "1980": 5,
      "1979": 6,
      "1977": 2,
      "1986": 2,
      "1985": 3,
      "1976": 3,
      "1975": 1,
      "1983": 1,
      "1982": 1,
      "1978": 2
    },
    "Patrick Depailler": {
      "1979": 2,
      "1978": 5,
      "1977": 3,
      "1976": 7,
      "1974": 1,
      "1975": 1
    },
    "Jody Scheckter": {
      "1979": 6,
      "1977": 9,
      "1976": 5,
      "1975": 3,
      "1974": 6,
      "1978": 4
    },
    "Clay Regazzoni": {
      "1979": 5,
      "1976": 4,
      "1975": 3,
      "1974": 7,
      "1970": 4,
      "1972": 2,
      "1971": 3
    },
    "Mario Andretti": {
      "1978": 7,
      "1977": 5,
      "1976": 3,
      "1971": 1,
      "1982": 1,
      "1979": 1,
      "1970": 1
    },
    "Ronnie Peterson": {
      "1978": 7,
      "1976": 1,
      "1974": 4,
      "1973": 7,
      "1971": 5,
      "1977": 1,
      "1972": 1
    },
    "Gunnar Nilsson": {
      "1977": 2,
      "1976": 2
    },
    "James Hunt": {
      "1977": 5,
      "1976": 8,
      "1975": 4,
      "1973": 2,
      "1978": 1,
      "1974": 3
    },
    "Emerson Fittipaldi": {
      "1975": 6,
      "1974": 7,
      "1973": 8,
      "1972": 8,
      "1970": 1,
      "1978": 1,
      "1971": 3,
      "1980": 1
    },
    "Carlos Pace": {
      "1975": 3,
      "1977": 1,
      "1974": 1,
      "1973": 1
    },
    "Jochen Mass": {
      "1975": 4,
      "1977": 2,
      "1976": 2
    },
    "Vittorio Brambilla": {
      "1975": 1
    },
    "Jackie Stewart": {
      "1973": 8,
      "1972": 5,
      "1971": 7,
      "1970": 4,
      "1969": 7,
      "1968": 4,
      "1966": 1,
      "1965": 5,
      "1967": 2
    },
    "Jacky Ickx": {
      "1972": 4,
      "1971": 3,
      "1970": 5,
      "1969": 5,
      "1968": 4,
      "1975": 1,
      "1974": 2,
      "1973": 1
    },
    "Jo Siffert": {
      "1971": 2,
      "1968": 1,
      "1969": 2,
      "1964": 1
    },
    "Jack Brabham": {
      "1970": 4,
      "1967": 6,
      "1966": 5,
      "1960": 5,
      "1959": 5,
      "1969": 2,
      "1963": 1,
      "1965": 1,
      "1964": 2
    },
    "Jochen Rindt": {
      "1970": 5,
      "1969": 3,
      "1966": 3,
      "1968": 2
    },
    "Pedro Rodríguez": {
      "1970": 2,
      "1967": 1,
      "1971": 1,
      "1968": 3
    },
    "Graham Hill": {
      "1969": 2,
      "1968": 6,
      "1965": 6,
      "1964": 5,
      "1963": 5,
      "1962": 6,
      "1967": 2,
      "1966": 3,
      "1960": 1
    },
    "Jim Clark": {
      "1968": 1,
      "1967": 5,
      "1966": 2,
      "1965": 6,
      "1964": 3,
      "1963": 9,
      "1962": 3,
      "1961": 2,
      "1960": 1
    },
    "Bruce McLaren": {
      "1968": 3,
      "1962": 5,
      "1960": 6,
      "1959": 2,
      "1970": 1,
      "1969": 3,
      "1964": 2,
      "1963": 3,
      "1965": 1,
      "1961": 1
    },
    "Dan Gurney": {
      "1967": 2,
      "1964": 2,
      "1962": 2,
      "1965": 5,
      "1963": 3,
      "1961": 3,
      "1959": 2
    },
    "John Surtees": {
      "1967": 2,
      "1966": 4,
      "1964": 6,
      "1963": 3,
      "1968": 2,
      "1965": 3,
      "1962": 2,
      "1960": 1,
      "1969": 1
    },
    "Richie Ginther": {
      "1965": 1,
      "1964": 2,
      "1963": 5,
      "1962": 2,
      "1961": 3,
      "1960": 1
    },
    "Lorenzo Bandini": {
      "1964": 4,
      "1966": 2,
      "1965": 1,
      "1962": 1
    },
    "Stirling Moss": {
      "1961": 2,
      "1960": 3,
      "1959": 3,
      "1958": 5,
      "1957": 3,
      "1956": 4,
      "1955": 3,
      "1954": 1
    },
    "Innes Ireland": {
      "1961": 1,
      "1960": 3
    },
    "Jim Rathmann": {
      "1960": 1,
      "1959": 1,
      "1957": 1,
      "1952": 1
    },
    "Jo Bonnier": {
      "1959": 1
    },
    "Maurice Trintignant": {
      "1958": 2,
      "1955": 3,
      "1959": 2,
      "1954": 2,
      "1960": 1
    },
    "Jimmy Bryan": {
      "1958": 1,
      "1954": 1,
      "1957": 1
    },
    "Mike Hawthorn": {
      "1958": 7,
      "1954": 4,
      "1953": 3,
      "1957": 2,
      "1956": 1,
      "1952": 1
    },
    "Juan Fangio": {
      "1957": 6,
      "1956": 5,
      "1955": 5,
      "1954": 7,
      "1953": 4,
      "1951": 5,
      "1950": 3
    },
    "Luigi Musso": {
      "1956": 1,
      "1958": 2,
      "1957": 2,
      "1954": 1,
      "1955": 1
    },
    "Alberto Ascari": {
      "1953": 5,
      "1952": 6,
      "1951": 4,
      "1950": 2
    },
    "Nino Farina": {
      "1953": 5,
      "1951": 4,
      "1950": 3,
      "1955": 3,
      "1954": 1,
      "1952": 4
    },
    "Nico Rosberg": {
      "2012": 2,
      "2013": 4,
      "2014": 15,
      "2015": 15,
      "2016": 16,
      "2008": 2,
      "2010": 3
    },
    "Daniel Ricciardo": {
      "2014": 8,
      "2016": 8,
      "2017": 9,
      "2018": 2,
      "2021": 1,
      "2015": 2,
      "2020": 2
    },
    "Max Verstappen": {
      "2016": 7,
      "2017": 4,
      "2018": 11,
      "2019": 9,
      "2020": 11,
      "2021": 18,
      "2022": 17,
      "2023": 21,
      "2024": 14
    },
    "Valtteri Bottas": {
      "2017": 13,
      "2019": 15,
      "2020": 11,
      "2021": 11,
      "2014": 6,
      "2018": 8,
      "2015": 2,
      "2016": 1
    },
    "Charles Leclerc": {
      "2019": 10,
      "2022": 11,
      "2024": 13,
      "2020": 2,
      "2021": 1,
      "2023": 6
    },
    "Pierre Gasly": {
      "2020": 1,
      "2019": 1,
      "2021": 1,
      "2023": 1,
      "2024": 1
    },
    "Sergio Pérez": {
      "2020": 2,
      "2021": 5,
      "2022": 11,
      "2023": 9,
      "2012": 3,
      "2024": 4,
      "2014": 1,
      "2015": 1,
      "2016": 2,
      "2018": 1
    },
    "Esteban Ocon": {
      "2021": 1,
      "2020": 1,
      "2024": 1,
      "2023": 1
    },
    "Carlos Sainz": {
      "2022": 9,
      "2023": 3,
      "2024": 9,
      "2020": 1,
      "2021": 4,
      "2019": 1
    },
    "George Russell": {
      "2022": 8,
      "2024": 4,
      "2021": 1,
      "2023": 2
    },
    "Lando Norris": {
      "2024": 13,
      "2021": 4,
      "2023": 7,
      "2020": 1,
      "2022": 1
    },
    "Oscar Piastri": {
      "2024": 8,
      "2023": 2
    },
    "Nick Heidfeld": {
      "2009": 1,
      "2008": 4,
      "2007": 2,
      "2005": 3,
      "2006": 1,
      "2001": 1,
      "2011": 1
    },
    "Timo Glock": {
      "2009": 2,
      "2008": 1
    },
    "Nelson Piquet Jr.": {
      "2008": 1
    },
    "Mika Salo": {
      "1999": 2
    },
    "Nicola Larini": {
      "1994": 1
    },
    "Stefano Modena": {
      "1991": 1,
      "1989": 1
    },
    "Ivan Capelli": {
      "1990": 1,
      "1988": 2
    },
    "Stefan Johansson": {
      "1987": 5,
      "1985": 2,
      "1989": 1,
      "1986": 4
    },
    "Derek Warwick": {
      "1984": 4
    },
    "Eddie Cheever": {
      "1983": 4,
      "1982": 3,
      "1989": 1,
      "1988": 1
    },
    "Andrea de Cesaris": {
      "1983": 2,
      "1989": 1,
      "1987": 1,
      "1982": 1
    },
    "Chris Amon": {
      "1970": 3,
      "1968": 1,
      "1972": 1,
      "1971": 1,
      "1969": 1,
      "1967": 4
    },
    "Richard Attwood": {
      "1968": 1
    },
    "Masten Gregory": {
      "1959": 2,
      "1957": 1
    },
    "Harry Schell": {
      "1958": 1,
      "1957": 1
    },
    "Jean Behra": {
      "1957": 1,
      "1956": 5,
      "1958": 1,
      "1955": 1,
      "1952": 1
    },
    "Eugenio Castellotti": {
      "1956": 1,
      "1955": 2
    },
    "Karl Kling": {
      "1954": 1,
      "1955": 1
    },
    "Luigi Villoresi": {
      "1953": 3,
      "1952": 2,
      "1951": 3
    },
    "Romain Grosjean": {
      "2012": 3,
      "2013": 6,
      "2015": 1
    },
    "Kevin Magnussen": {
      "2014": 1
    },
    "Daniil Kvyat": {
      "2015": 1,
      "2016": 1,
      "2019": 1
    },
    "Alexander Wurz": {
      "2007": 1,
      "2005": 1,
      "1997": 1
    },
    "Takuma Sato": {
      "2004": 1
    },
    "Jos Verstappen": {
      "1994": 2
    },
    "Aguri Suzuki": {
      "1990": 1
    },
    "Maurício Gugelmin": {
      "1989": 1
    },
    "Philippe Streiff": {
      "1985": 1
    },
    "Jean-Pierre Jarier": {
      "1979": 2,
      "1974": 1
    },
    "Hans-Joachim Stuck": {
      "1977": 2
    },
    "Tom Pryce": {
      "1976": 1,
      "1975": 1
    },
    "Henri Pescarolo": {
      "1970": 1
    },
    "Mike Spence": {
      "1965": 1
    },
    "Johnny Thomson": {
      "1959": 1
    },
    "Don Freeland": {
      "1956": 1
    },
    "Robert Manzon": {
      "1954": 1,
      "1952": 1
    },
    "Duane Carter": {
      "1953": 1
    },
    "Lance Stroll": {
      "2017": 1,
      "2020": 2
    },
    "Alexander Albon": {
      "2020": 2
    }
  },
  "driverProfiles": [
    {
      "id": "adrian-sutil",
      "name": "Adrian Sutil",
      "firstYear": 2007,
      "lastYear": 2014,
      "seasons": 7,
      "rating": 56
    },
    {
      "id": "adrian-campos",
      "name": "Adrián Campos",
      "firstYear": 1987,
      "lastYear": 1988,
      "seasons": 2,
      "rating": 60
    },
    {
      "id": "aguri-suzuki",
      "name": "Aguri Suzuki",
      "firstYear": 1988,
      "lastYear": 1995,
      "seasons": 8,
      "rating": 55
    },
    {
      "id": "al-herman",
      "name": "Al Herman",
      "firstYear": 1955,
      "lastYear": 1960,
      "seasons": 5,
      "rating": 51
    },
    {
      "id": "al-keller",
      "name": "Al Keller",
      "firstYear": 1955,
      "lastYear": 1959,
      "seasons": 5,
      "rating": 47
    },
    {
      "id": "alain-prost",
      "name": "Alain Prost",
      "firstYear": 1980,
      "lastYear": 1993,
      "seasons": 13,
      "rating": 99
    },
    {
      "id": "alan-jones",
      "name": "Alan Jones",
      "firstYear": 1975,
      "lastYear": 1986,
      "seasons": 10,
      "rating": 72
    },
    {
      "id": "alan-rollinson",
      "name": "Alan Rollinson",
      "firstYear": 1965,
      "lastYear": 1965,
      "seasons": 1,
      "rating": 51
    },
    {
      "id": "alberto-ascari",
      "name": "Alberto Ascari",
      "firstYear": 1950,
      "lastYear": 1955,
      "seasons": 6,
      "rating": 87
    },
    {
      "id": "alessandro-nannini",
      "name": "Alessandro Nannini",
      "firstYear": 1986,
      "lastYear": 1990,
      "seasons": 5,
      "rating": 66
    },
    {
      "id": "alessandro-pesenti-rossi",
      "name": "Alessandro Pesenti-Rossi",
      "firstYear": 1976,
      "lastYear": 1976,
      "seasons": 1,
      "rating": 47
    },
    {
      "id": "alex-blignaut",
      "name": "Alex Blignaut",
      "firstYear": 1965,
      "lastYear": 1965,
      "seasons": 1,
      "rating": 51
    },
    {
      "id": "alex-caffi",
      "name": "Alex Caffi",
      "firstYear": 1986,
      "lastYear": 1991,
      "seasons": 6,
      "rating": 55
    },
    {
      "id": "alex-ribeiro",
      "name": "Alex Ribeiro",
      "firstYear": 1976,
      "lastYear": 1979,
      "seasons": 3,
      "rating": 48
    },
    {
      "id": "alexander-albon",
      "name": "Alexander Albon",
      "firstYear": 2019,
      "lastYear": 2024,
      "seasons": 5,
      "rating": 52
    },
    {
      "id": "alexander-wurz",
      "name": "Alexander Wurz",
      "firstYear": 1997,
      "lastYear": 2007,
      "seasons": 6,
      "rating": 53
    },
    {
      "id": "andrea-de-cesaris",
      "name": "Andrea de Cesaris",
      "firstYear": 1980,
      "lastYear": 1994,
      "seasons": 15,
      "rating": 59
    },
    {
      "id": "andy-linden",
      "name": "Andy Linden",
      "firstYear": 1951,
      "lastYear": 1957,
      "seasons": 7,
      "rating": 61
    },
    {
      "id": "anthony-davidson",
      "name": "Anthony Davidson",
      "firstYear": 2002,
      "lastYear": 2008,
      "seasons": 4,
      "rating": 48
    },
    {
      "id": "arturo-merzario",
      "name": "Arturo Merzario",
      "firstYear": 1972,
      "lastYear": 1979,
      "seasons": 8,
      "rating": 52
    },
    {
      "id": "ayrton-senna",
      "name": "Ayrton Senna",
      "firstYear": 1984,
      "lastYear": 1994,
      "seasons": 11,
      "rating": 99
    },
    {
      "id": "bernd-schneider",
      "name": "Bernd Schneider",
      "firstYear": 1988,
      "lastYear": 1990,
      "seasons": 3,
      "rating": 55
    },
    {
      "id": "bob-evans",
      "name": "Bob Evans",
      "firstYear": 1975,
      "lastYear": 1976,
      "seasons": 2,
      "rating": 48
    },
    {
      "id": "boy-lunger",
      "name": "Boy Lunger",
      "firstYear": 1976,
      "lastYear": 1977,
      "seasons": 2,
      "rating": 53
    },
    {
      "id": "brausch-niemann",
      "name": "Brausch Niemann",
      "firstYear": 1963,
      "lastYear": 1965,
      "seasons": 2,
      "rating": 57
    },
    {
      "id": "brett-lunger",
      "name": "Brett Lunger",
      "firstYear": 1975,
      "lastYear": 1978,
      "seasons": 4,
      "rating": 50
    },
    {
      "id": "bruce-mclaren",
      "name": "Bruce McLaren",
      "firstYear": 1958,
      "lastYear": 1970,
      "seasons": 13,
      "rating": 67
    },
    {
      "id": "carlos-pace",
      "name": "Carlos Pace",
      "firstYear": 1972,
      "lastYear": 1977,
      "seasons": 6,
      "rating": 57
    },
    {
      "id": "carlos-reutemann",
      "name": "Carlos Reutemann",
      "firstYear": 1972,
      "lastYear": 1982,
      "seasons": 11,
      "rating": 72
    },
    {
      "id": "carlos-sainz",
      "name": "Carlos Sainz",
      "firstYear": 2015,
      "lastYear": 2024,
      "seasons": 10,
      "rating": 74
    },
    {
      "id": "charles-leclerc",
      "name": "Charles Leclerc",
      "firstYear": 2018,
      "lastYear": 2024,
      "seasons": 7,
      "rating": 75
    },
    {
      "id": "chris-amon",
      "name": "Chris Amon",
      "firstYear": 1963,
      "lastYear": 1976,
      "seasons": 14,
      "rating": 67
    },
    {
      "id": "clay-regazzoni",
      "name": "Clay Regazzoni",
      "firstYear": 1970,
      "lastYear": 1980,
      "seasons": 11,
      "rating": 77
    },
    {
      "id": "damon-hill",
      "name": "Damon Hill",
      "firstYear": 1992,
      "lastYear": 1999,
      "seasons": 8,
      "rating": 92
    },
    {
      "id": "dan-gurney",
      "name": "Dan Gurney",
      "firstYear": 1959,
      "lastYear": 1970,
      "seasons": 11,
      "rating": 75
    },
    {
      "id": "daniel-ricciardo",
      "name": "Daniel Ricciardo",
      "firstYear": 2011,
      "lastYear": 2024,
      "seasons": 14,
      "rating": 70
    },
    {
      "id": "daniil-kvyat",
      "name": "Daniil Kvyat",
      "firstYear": 2014,
      "lastYear": 2020,
      "seasons": 6,
      "rating": 56
    },
    {
      "id": "dave-charlton",
      "name": "Dave Charlton",
      "firstYear": 1965,
      "lastYear": 1975,
      "seasons": 9,
      "rating": 58
    },
    {
      "id": "david-clapham",
      "name": "David Clapham",
      "firstYear": 1965,
      "lastYear": 1965,
      "seasons": 1,
      "rating": 56
    },
    {
      "id": "david-coulthard",
      "name": "David Coulthard",
      "firstYear": 1994,
      "lastYear": 2008,
      "seasons": 15,
      "rating": 81
    },
    {
      "id": "david-prophet",
      "name": "David Prophet",
      "firstYear": 1963,
      "lastYear": 1965,
      "seasons": 2,
      "rating": 47
    },
    {
      "id": "derek-warwick",
      "name": "Derek Warwick",
      "firstYear": 1981,
      "lastYear": 1993,
      "seasons": 11,
      "rating": 59
    },
    {
      "id": "don-freeland",
      "name": "Don Freeland",
      "firstYear": 1953,
      "lastYear": 1960,
      "seasons": 8,
      "rating": 63
    },
    {
      "id": "doug-serrurier",
      "name": "Doug Serrurier",
      "firstYear": 1962,
      "lastYear": 1965,
      "seasons": 3,
      "rating": 46
    },
    {
      "id": "duane-carter",
      "name": "Duane Carter",
      "firstYear": 1950,
      "lastYear": 1960,
      "seasons": 8,
      "rating": 61
    },
    {
      "id": "eddie-cheever",
      "name": "Eddie Cheever",
      "firstYear": 1978,
      "lastYear": 1989,
      "seasons": 11,
      "rating": 65
    },
    {
      "id": "eddie-irvine",
      "name": "Eddie Irvine",
      "firstYear": 1993,
      "lastYear": 2002,
      "seasons": 10,
      "rating": 65
    },
    {
      "id": "eddie-johnson",
      "name": "Eddie Johnson",
      "firstYear": 1952,
      "lastYear": 1960,
      "seasons": 9,
      "rating": 55
    },
    {
      "id": "eddie-russo",
      "name": "Eddie Russo",
      "firstYear": 1955,
      "lastYear": 1960,
      "seasons": 4,
      "rating": 61
    },
    {
      "id": "emerson-fittipaldi",
      "name": "Emerson Fittipaldi",
      "firstYear": 1970,
      "lastYear": 1980,
      "seasons": 11,
      "rating": 83
    },
    {
      "id": "emilio-zapico",
      "name": "Emilio Zapico",
      "firstYear": 1976,
      "lastYear": 1976,
      "seasons": 1,
      "rating": 59
    },
    {
      "id": "esteban-gutierrez",
      "name": "Esteban Gutiérrez",
      "firstYear": 2013,
      "lastYear": 2016,
      "seasons": 3,
      "rating": 53
    },
    {
      "id": "esteban-ocon",
      "name": "Esteban Ocon",
      "firstYear": 2016,
      "lastYear": 2024,
      "seasons": 8,
      "rating": 55
    },
    {
      "id": "esteban-tuero",
      "name": "Esteban Tuero",
      "firstYear": 1998,
      "lastYear": 1998,
      "seasons": 1,
      "rating": 59
    },
    {
      "id": "eugenio-castellotti",
      "name": "Eugenio Castellotti",
      "firstYear": 1955,
      "lastYear": 1957,
      "seasons": 3,
      "rating": 56
    },
    {
      "id": "felipe-massa",
      "name": "Felipe Massa",
      "firstYear": 2002,
      "lastYear": 2017,
      "seasons": 15,
      "rating": 80
    },
    {
      "id": "felipe-nasr",
      "name": "Felipe Nasr",
      "firstYear": 2015,
      "lastYear": 2016,
      "seasons": 2,
      "rating": 49
    },
    {
      "id": "fernando-alonso",
      "name": "Fernando Alonso",
      "firstYear": 2001,
      "lastYear": 2024,
      "seasons": 21,
      "rating": 99
    },
    {
      "id": "franco-colapinto",
      "name": "Franco Colapinto",
      "firstYear": 2024,
      "lastYear": 2024,
      "seasons": 1,
      "rating": 52
    },
    {
      "id": "frank-gardner",
      "name": "Frank Gardner",
      "firstYear": 1964,
      "lastYear": 1968,
      "seasons": 3,
      "rating": 54
    },
    {
      "id": "gabriele-tarquini",
      "name": "Gabriele Tarquini",
      "firstYear": 1987,
      "lastYear": 1995,
      "seasons": 7,
      "rating": 51
    },
    {
      "id": "george-russell",
      "name": "George Russell",
      "firstYear": 2019,
      "lastYear": 2024,
      "seasons": 6,
      "rating": 59
    },
    {
      "id": "gerhard-berger",
      "name": "Gerhard Berger",
      "firstYear": 1984,
      "lastYear": 1997,
      "seasons": 14,
      "rating": 80
    },
    {
      "id": "giancarlo-fisichella",
      "name": "Giancarlo Fisichella",
      "firstYear": 1996,
      "lastYear": 2009,
      "seasons": 14,
      "rating": 65
    },
    {
      "id": "graham-hill",
      "name": "Graham Hill",
      "firstYear": 1958,
      "lastYear": 1975,
      "seasons": 18,
      "rating": 99
    },
    {
      "id": "guanyu-zhou",
      "name": "Guanyu Zhou",
      "firstYear": 2022,
      "lastYear": 2024,
      "seasons": 3,
      "rating": 54
    },
    {
      "id": "gunnar-nilsson",
      "name": "Gunnar Nilsson",
      "firstYear": 1976,
      "lastYear": 1977,
      "seasons": 2,
      "rating": 59
    },
    {
      "id": "guy-edwards",
      "name": "Guy Edwards",
      "firstYear": 1974,
      "lastYear": 1977,
      "seasons": 3,
      "rating": 51
    },
    {
      "id": "hans-binder",
      "name": "Hans Binder",
      "firstYear": 1976,
      "lastYear": 1978,
      "seasons": 3,
      "rating": 49
    },
    {
      "id": "hans-joachim-stuck",
      "name": "Hans-Joachim Stuck",
      "firstYear": 1974,
      "lastYear": 1979,
      "seasons": 6,
      "rating": 65
    },
    {
      "id": "harald-ertl",
      "name": "Harald Ertl",
      "firstYear": 1975,
      "lastYear": 1980,
      "seasons": 5,
      "rating": 50
    },
    {
      "id": "harry-schell",
      "name": "Harry Schell",
      "firstYear": 1950,
      "lastYear": 1960,
      "seasons": 11,
      "rating": 55
    },
    {
      "id": "heikki-kovalainen",
      "name": "Heikki Kovalainen",
      "firstYear": 2007,
      "lastYear": 2013,
      "seasons": 7,
      "rating": 65
    },
    {
      "id": "heinz-harald-frentzen",
      "name": "Heinz-Harald Frentzen",
      "firstYear": 1994,
      "lastYear": 2003,
      "seasons": 10,
      "rating": 71
    },
    {
      "id": "henri-pescarolo",
      "name": "Henri Pescarolo",
      "firstYear": 1968,
      "lastYear": 1976,
      "seasons": 7,
      "rating": 53
    },
    {
      "id": "hernando-da-silva-ramos",
      "name": "Hernando da Silva Ramos",
      "firstYear": 1955,
      "lastYear": 1956,
      "seasons": 2,
      "rating": 55
    },
    {
      "id": "ian-ashley",
      "name": "Ian Ashley",
      "firstYear": 1974,
      "lastYear": 1977,
      "seasons": 4,
      "rating": 60
    },
    {
      "id": "ian-raby",
      "name": "Ian Raby",
      "firstYear": 1963,
      "lastYear": 1965,
      "seasons": 3,
      "rating": 58
    },
    {
      "id": "ingo-hoffmann",
      "name": "Ingo Hoffmann",
      "firstYear": 1976,
      "lastYear": 1977,
      "seasons": 2,
      "rating": 59
    },
    {
      "id": "innes-ireland",
      "name": "Innes Ireland",
      "firstYear": 1959,
      "lastYear": 1966,
      "seasons": 8,
      "rating": 68
    },
    {
      "id": "ivan-capelli",
      "name": "Ivan Capelli",
      "firstYear": 1985,
      "lastYear": 1993,
      "seasons": 9,
      "rating": 60
    },
    {
      "id": "jack-brabham",
      "name": "Jack Brabham",
      "firstYear": 1955,
      "lastYear": 1970,
      "seasons": 16,
      "rating": 91
    },
    {
      "id": "jack-doohan",
      "name": "Jack Doohan",
      "firstYear": 2024,
      "lastYear": 2024,
      "seasons": 1,
      "rating": 52
    },
    {
      "id": "jack-fairman",
      "name": "Jack Fairman",
      "firstYear": 1953,
      "lastYear": 1961,
      "seasons": 8,
      "rating": 52
    },
    {
      "id": "jackie-pretorius",
      "name": "Jackie Pretorius",
      "firstYear": 1965,
      "lastYear": 1973,
      "seasons": 4,
      "rating": 51
    },
    {
      "id": "jackie-stewart",
      "name": "Jackie Stewart",
      "firstYear": 1965,
      "lastYear": 1973,
      "seasons": 9,
      "rating": 99
    },
    {
      "id": "jacky-ickx",
      "name": "Jacky Ickx",
      "firstYear": 1967,
      "lastYear": 1979,
      "seasons": 13,
      "rating": 72
    },
    {
      "id": "jacques-laffite",
      "name": "Jacques Laffite",
      "firstYear": 1974,
      "lastYear": 1986,
      "seasons": 13,
      "rating": 76
    },
    {
      "id": "jacques-pollet",
      "name": "Jacques Pollet",
      "firstYear": 1954,
      "lastYear": 1955,
      "seasons": 2,
      "rating": 48
    },
    {
      "id": "jacques-villeneuve",
      "name": "Jacques Villeneuve",
      "firstYear": 1996,
      "lastYear": 2006,
      "seasons": 11,
      "rating": 85
    },
    {
      "id": "james-hunt",
      "name": "James Hunt",
      "firstYear": 1973,
      "lastYear": 1979,
      "seasons": 7,
      "rating": 80
    },
    {
      "id": "jan-magnussen",
      "name": "Jan Magnussen",
      "firstYear": 1995,
      "lastYear": 1998,
      "seasons": 3,
      "rating": 57
    },
    {
      "id": "jarno-trulli",
      "name": "Jarno Trulli",
      "firstYear": 1997,
      "lastYear": 2011,
      "seasons": 15,
      "rating": 69
    },
    {
      "id": "jean-alesi",
      "name": "Jean Alesi",
      "firstYear": 1989,
      "lastYear": 2001,
      "seasons": 13,
      "rating": 68
    },
    {
      "id": "jean-behra",
      "name": "Jean Behra",
      "firstYear": 1952,
      "lastYear": 1959,
      "seasons": 8,
      "rating": 61
    },
    {
      "id": "jean-louis-schlesser",
      "name": "Jean-Louis Schlesser",
      "firstYear": 1983,
      "lastYear": 1988,
      "seasons": 2,
      "rating": 56
    },
    {
      "id": "jean-pierre-jarier",
      "name": "Jean-Pierre Jarier",
      "firstYear": 1971,
      "lastYear": 1983,
      "seasons": 12,
      "rating": 55
    },
    {
      "id": "jenson-button",
      "name": "Jenson Button",
      "firstYear": 2000,
      "lastYear": 2017,
      "seasons": 18,
      "rating": 93
    },
    {
      "id": "jerry-hoyt",
      "name": "Jerry Hoyt",
      "firstYear": 1950,
      "lastYear": 1955,
      "seasons": 4,
      "rating": 58
    },
    {
      "id": "jim-clark",
      "name": "Jim Clark",
      "firstYear": 1960,
      "lastYear": 1968,
      "seasons": 9,
      "rating": 86
    },
    {
      "id": "jim-rathmann",
      "name": "Jim Rathmann",
      "firstYear": 1950,
      "lastYear": 1960,
      "seasons": 10,
      "rating": 66
    },
    {
      "id": "jimmy-bryan",
      "name": "Jimmy Bryan",
      "firstYear": 1952,
      "lastYear": 1960,
      "seasons": 9,
      "rating": 54
    },
    {
      "id": "jimmy-reece",
      "name": "Jimmy Reece",
      "firstYear": 1952,
      "lastYear": 1958,
      "seasons": 6,
      "rating": 57
    },
    {
      "id": "jo-bonnier",
      "name": "Jo Bonnier",
      "firstYear": 1956,
      "lastYear": 1971,
      "seasons": 16,
      "rating": 67
    },
    {
      "id": "jo-siffert",
      "name": "Jo Siffert",
      "firstYear": 1962,
      "lastYear": 1971,
      "seasons": 10,
      "rating": 57
    },
    {
      "id": "jochen-mass",
      "name": "Jochen Mass",
      "firstYear": 1973,
      "lastYear": 1982,
      "seasons": 9,
      "rating": 70
    },
    {
      "id": "jochen-rindt",
      "name": "Jochen Rindt",
      "firstYear": 1964,
      "lastYear": 1970,
      "seasons": 7,
      "rating": 79
    },
    {
      "id": "jody-scheckter",
      "name": "Jody Scheckter",
      "firstYear": 1972,
      "lastYear": 1980,
      "seasons": 9,
      "rating": 73
    },
    {
      "id": "john-surtees",
      "name": "John Surtees",
      "firstYear": 1960,
      "lastYear": 1972,
      "seasons": 13,
      "rating": 78
    },
    {
      "id": "john-watson",
      "name": "John Watson",
      "firstYear": 1973,
      "lastYear": 1985,
      "seasons": 12,
      "rating": 66
    },
    {
      "id": "johnny-herbert",
      "name": "Johnny Herbert",
      "firstYear": 1989,
      "lastYear": 2000,
      "seasons": 12,
      "rating": 67
    },
    {
      "id": "johnny-thomson",
      "name": "Johnny Thomson",
      "firstYear": 1953,
      "lastYear": 1960,
      "seasons": 8,
      "rating": 62
    },
    {
      "id": "jolyon-palmer",
      "name": "Jolyon Palmer",
      "firstYear": 2016,
      "lastYear": 2017,
      "seasons": 2,
      "rating": 47
    },
    {
      "id": "jonathan-palmer",
      "name": "Jonathan Palmer",
      "firstYear": 1983,
      "lastYear": 1989,
      "seasons": 7,
      "rating": 52
    },
    {
      "id": "jos-verstappen",
      "name": "Jos Verstappen",
      "firstYear": 1994,
      "lastYear": 2003,
      "seasons": 8,
      "rating": 54
    },
    {
      "id": "juan-fangio",
      "name": "Juan Fangio",
      "firstYear": 1950,
      "lastYear": 1958,
      "seasons": 8,
      "rating": 99
    },
    {
      "id": "julian-bailey",
      "name": "Julian Bailey",
      "firstYear": 1988,
      "lastYear": 1991,
      "seasons": 2,
      "rating": 54
    },
    {
      "id": "karl-kling",
      "name": "Karl Kling",
      "firstYear": 1954,
      "lastYear": 1955,
      "seasons": 2,
      "rating": 55
    },
    {
      "id": "kazuki-nakajima",
      "name": "Kazuki Nakajima",
      "firstYear": 2007,
      "lastYear": 2009,
      "seasons": 3,
      "rating": 60
    },
    {
      "id": "keith-andrews",
      "name": "Keith Andrews",
      "firstYear": 1955,
      "lastYear": 1956,
      "seasons": 2,
      "rating": 50
    },
    {
      "id": "ken-wharton",
      "name": "Ken Wharton",
      "firstYear": 1952,
      "lastYear": 1955,
      "seasons": 4,
      "rating": 52
    },
    {
      "id": "kenneth-mcalpine",
      "name": "Kenneth McAlpine",
      "firstYear": 1952,
      "lastYear": 1955,
      "seasons": 3,
      "rating": 58
    },
    {
      "id": "kevin-magnussen",
      "name": "Kevin Magnussen",
      "firstYear": 2014,
      "lastYear": 2024,
      "seasons": 10,
      "rating": 60
    },
    {
      "id": "kimi-raikkonen",
      "name": "Kimi Räikkönen",
      "firstYear": 2001,
      "lastYear": 2021,
      "seasons": 19,
      "rating": 99
    },
    {
      "id": "lance-stroll",
      "name": "Lance Stroll",
      "firstYear": 2017,
      "lastYear": 2024,
      "seasons": 8,
      "rating": 66
    },
    {
      "id": "lando-norris",
      "name": "Lando Norris",
      "firstYear": 2019,
      "lastYear": 2024,
      "seasons": 6,
      "rating": 64
    },
    {
      "id": "larry-perkins",
      "name": "Larry Perkins",
      "firstYear": 1974,
      "lastYear": 1977,
      "seasons": 3,
      "rating": 51
    },
    {
      "id": "lella-lombardi",
      "name": "Lella Lombardi",
      "firstYear": 1974,
      "lastYear": 1976,
      "seasons": 3,
      "rating": 49
    },
    {
      "id": "leslie-marr",
      "name": "Leslie Marr",
      "firstYear": 1954,
      "lastYear": 1955,
      "seasons": 2,
      "rating": 46
    },
    {
      "id": "lewis-hamilton",
      "name": "Lewis Hamilton",
      "firstYear": 2007,
      "lastYear": 2024,
      "seasons": 18,
      "rating": 99
    },
    {
      "id": "liam-lawson",
      "name": "Liam Lawson",
      "firstYear": 2023,
      "lastYear": 2024,
      "seasons": 2,
      "rating": 50
    },
    {
      "id": "logan-sargeant",
      "name": "Logan Sargeant",
      "firstYear": 2023,
      "lastYear": 2024,
      "seasons": 2,
      "rating": 54
    },
    {
      "id": "lorenzo-bandini",
      "name": "Lorenzo Bandini",
      "firstYear": 1961,
      "lastYear": 1967,
      "seasons": 7,
      "rating": 59
    },
    {
      "id": "loris-kessel",
      "name": "Loris Kessel",
      "firstYear": 1976,
      "lastYear": 1977,
      "seasons": 2,
      "rating": 53
    },
    {
      "id": "luigi-musso",
      "name": "Luigi Musso",
      "firstYear": 1953,
      "lastYear": 1958,
      "seasons": 6,
      "rating": 61
    },
    {
      "id": "luigi-piotti",
      "name": "Luigi Piotti",
      "firstYear": 1955,
      "lastYear": 1958,
      "seasons": 4,
      "rating": 60
    },
    {
      "id": "luigi-villoresi",
      "name": "Luigi Villoresi",
      "firstYear": 1950,
      "lastYear": 1956,
      "seasons": 7,
      "rating": 68
    },
    {
      "id": "luis-perez-sala",
      "name": "Luis Pérez-Sala",
      "firstYear": 1988,
      "lastYear": 1989,
      "seasons": 2,
      "rating": 49
    },
    {
      "id": "marcus-ericsson",
      "name": "Marcus Ericsson",
      "firstYear": 2014,
      "lastYear": 2018,
      "seasons": 5,
      "rating": 53
    },
    {
      "id": "mario-andretti",
      "name": "Mario Andretti",
      "firstYear": 1968,
      "lastYear": 1982,
      "seasons": 14,
      "rating": 85
    },
    {
      "id": "mark-webber",
      "name": "Mark Webber",
      "firstYear": 2002,
      "lastYear": 2013,
      "seasons": 12,
      "rating": 70
    },
    {
      "id": "masahiro-hasemi",
      "name": "Masahiro Hasemi",
      "firstYear": 1976,
      "lastYear": 1976,
      "seasons": 1,
      "rating": 48
    },
    {
      "id": "masten-gregory",
      "name": "Masten Gregory",
      "firstYear": 1957,
      "lastYear": 1965,
      "seasons": 8,
      "rating": 63
    },
    {
      "id": "maurice-trintignant",
      "name": "Maurice Trintignant",
      "firstYear": 1950,
      "lastYear": 1964,
      "seasons": 15,
      "rating": 65
    },
    {
      "id": "mauricio-gugelmin",
      "name": "Maurício Gugelmin",
      "firstYear": 1988,
      "lastYear": 1992,
      "seasons": 5,
      "rating": 54
    },
    {
      "id": "max-verstappen",
      "name": "Max Verstappen",
      "firstYear": 2015,
      "lastYear": 2024,
      "seasons": 10,
      "rating": 99
    },
    {
      "id": "michael-schumacher",
      "name": "Michael Schumacher",
      "firstYear": 1991,
      "lastYear": 2012,
      "seasons": 19,
      "rating": 99
    },
    {
      "id": "michel-leclere",
      "name": "Michel Leclère",
      "firstYear": 1975,
      "lastYear": 1976,
      "seasons": 2,
      "rating": 52
    },
    {
      "id": "michele-alboreto",
      "name": "Michele Alboreto",
      "firstYear": 1981,
      "lastYear": 1994,
      "seasons": 14,
      "rating": 75
    },
    {
      "id": "mika-hakkinen",
      "name": "Mika Häkkinen",
      "firstYear": 1991,
      "lastYear": 2001,
      "seasons": 11,
      "rating": 99
    },
    {
      "id": "mika-salo",
      "name": "Mika Salo",
      "firstYear": 1994,
      "lastYear": 2002,
      "seasons": 8,
      "rating": 56
    },
    {
      "id": "mike-hawthorn",
      "name": "Mike Hawthorn",
      "firstYear": 1952,
      "lastYear": 1958,
      "seasons": 7,
      "rating": 79
    },
    {
      "id": "mike-spence",
      "name": "Mike Spence",
      "firstYear": 1963,
      "lastYear": 1968,
      "seasons": 6,
      "rating": 53
    },
    {
      "id": "mike-wilds",
      "name": "Mike Wilds",
      "firstYear": 1974,
      "lastYear": 1976,
      "seasons": 3,
      "rating": 50
    },
    {
      "id": "moises-solana",
      "name": "Moisés Solana",
      "firstYear": 1963,
      "lastYear": 1968,
      "seasons": 6,
      "rating": 59
    },
    {
      "id": "nelson-piquet",
      "name": "Nelson Piquet",
      "firstYear": 1978,
      "lastYear": 1991,
      "seasons": 14,
      "rating": 99
    },
    {
      "id": "nelson-piquet-jr",
      "name": "Nelson Piquet Jr.",
      "firstYear": 2008,
      "lastYear": 2009,
      "seasons": 2,
      "rating": 57
    },
    {
      "id": "nick-heidfeld",
      "name": "Nick Heidfeld",
      "firstYear": 2000,
      "lastYear": 2011,
      "seasons": 12,
      "rating": 65
    },
    {
      "id": "nico-hulkenberg",
      "name": "Nico Hülkenberg",
      "firstYear": 2010,
      "lastYear": 2024,
      "seasons": 13,
      "rating": 53
    },
    {
      "id": "nico-rosberg",
      "name": "Nico Rosberg",
      "firstYear": 2006,
      "lastYear": 2016,
      "seasons": 11,
      "rating": 93
    },
    {
      "id": "nicola-larini",
      "name": "Nicola Larini",
      "firstYear": 1987,
      "lastYear": 1997,
      "seasons": 8,
      "rating": 52
    },
    {
      "id": "nigel-mansell",
      "name": "Nigel Mansell",
      "firstYear": 1980,
      "lastYear": 1995,
      "seasons": 15,
      "rating": 92
    },
    {
      "id": "niki-lauda",
      "name": "Niki Lauda",
      "firstYear": 1971,
      "lastYear": 1985,
      "seasons": 13,
      "rating": 99
    },
    {
      "id": "nino-farina",
      "name": "Nino Farina",
      "firstYear": 1950,
      "lastYear": 1955,
      "seasons": 6,
      "rating": 67
    },
    {
      "id": "oliver-bearman",
      "name": "Oliver Bearman",
      "firstYear": 2024,
      "lastYear": 2024,
      "seasons": 1,
      "rating": 48
    },
    {
      "id": "olivier-panis",
      "name": "Olivier Panis",
      "firstYear": 1994,
      "lastYear": 2004,
      "seasons": 10,
      "rating": 63
    },
    {
      "id": "oscar-larrauri",
      "name": "Oscar Larrauri",
      "firstYear": 1988,
      "lastYear": 1989,
      "seasons": 2,
      "rating": 58
    },
    {
      "id": "oscar-piastri",
      "name": "Oscar Piastri",
      "firstYear": 2023,
      "lastYear": 2024,
      "seasons": 2,
      "rating": 57
    },
    {
      "id": "pascal-wehrlein",
      "name": "Pascal Wehrlein",
      "firstYear": 2016,
      "lastYear": 2017,
      "seasons": 2,
      "rating": 51
    },
    {
      "id": "patrick-depailler",
      "name": "Patrick Depailler",
      "firstYear": 1972,
      "lastYear": 1980,
      "seasons": 8,
      "rating": 64
    },
    {
      "id": "paul-hawkins",
      "name": "Paul Hawkins",
      "firstYear": 1965,
      "lastYear": 1965,
      "seasons": 1,
      "rating": 57
    },
    {
      "id": "pedro-diniz",
      "name": "Pedro Diniz",
      "firstYear": 1995,
      "lastYear": 2000,
      "seasons": 6,
      "rating": 52
    },
    {
      "id": "pedro-rodriguez",
      "name": "Pedro Rodríguez",
      "firstYear": 1963,
      "lastYear": 1971,
      "seasons": 9,
      "rating": 58
    },
    {
      "id": "peter-de-klerk",
      "name": "Peter de Klerk",
      "firstYear": 1963,
      "lastYear": 1970,
      "seasons": 4,
      "rating": 55
    },
    {
      "id": "philippe-alliot",
      "name": "Philippe Alliot",
      "firstYear": 1984,
      "lastYear": 1994,
      "seasons": 9,
      "rating": 52
    },
    {
      "id": "philippe-streiff",
      "name": "Philippe Streiff",
      "firstYear": 1984,
      "lastYear": 1988,
      "seasons": 5,
      "rating": 60
    },
    {
      "id": "piercarlo-ghinzani",
      "name": "Piercarlo Ghinzani",
      "firstYear": 1981,
      "lastYear": 1989,
      "seasons": 8,
      "rating": 62
    },
    {
      "id": "pierluigi-martini",
      "name": "Pierluigi Martini",
      "firstYear": 1984,
      "lastYear": 1995,
      "seasons": 10,
      "rating": 52
    },
    {
      "id": "pierre-gasly",
      "name": "Pierre Gasly",
      "firstYear": 2017,
      "lastYear": 2024,
      "seasons": 8,
      "rating": 60
    },
    {
      "id": "ralf-schumacher",
      "name": "Ralf Schumacher",
      "firstYear": 1997,
      "lastYear": 2007,
      "seasons": 11,
      "rating": 70
    },
    {
      "id": "ray-reed",
      "name": "Ray Reed",
      "firstYear": 1965,
      "lastYear": 1965,
      "seasons": 1,
      "rating": 50
    },
    {
      "id": "renzo-zorzi",
      "name": "Renzo Zorzi",
      "firstYear": 1975,
      "lastYear": 1977,
      "seasons": 3,
      "rating": 51
    },
    {
      "id": "rene-arnoux",
      "name": "René Arnoux",
      "firstYear": 1978,
      "lastYear": 1989,
      "seasons": 12,
      "rating": 70
    },
    {
      "id": "ricardo-rosset",
      "name": "Ricardo Rosset",
      "firstYear": 1996,
      "lastYear": 1998,
      "seasons": 3,
      "rating": 51
    },
    {
      "id": "riccardo-patrese",
      "name": "Riccardo Patrese",
      "firstYear": 1977,
      "lastYear": 1993,
      "seasons": 17,
      "rating": 72
    },
    {
      "id": "richard-attwood",
      "name": "Richard Attwood",
      "firstYear": 1964,
      "lastYear": 1969,
      "seasons": 5,
      "rating": 59
    },
    {
      "id": "richie-ginther",
      "name": "Richie Ginther",
      "firstYear": 1960,
      "lastYear": 1967,
      "seasons": 8,
      "rating": 65
    },
    {
      "id": "rio-haryanto",
      "name": "Rio Haryanto",
      "firstYear": 2016,
      "lastYear": 2016,
      "seasons": 1,
      "rating": 53
    },
    {
      "id": "robert-kubica",
      "name": "Robert Kubica",
      "firstYear": 2006,
      "lastYear": 2021,
      "seasons": 7,
      "rating": 63
    },
    {
      "id": "robert-manzon",
      "name": "Robert Manzon",
      "firstYear": 1950,
      "lastYear": 1956,
      "seasons": 7,
      "rating": 64
    },
    {
      "id": "roberto-mieres",
      "name": "Roberto Mieres",
      "firstYear": 1953,
      "lastYear": 1955,
      "seasons": 3,
      "rating": 55
    },
    {
      "id": "romain-grosjean",
      "name": "Romain Grosjean",
      "firstYear": 2009,
      "lastYear": 2020,
      "seasons": 10,
      "rating": 69
    },
    {
      "id": "ronnie-bucknum",
      "name": "Ronnie Bucknum",
      "firstYear": 1964,
      "lastYear": 1966,
      "seasons": 3,
      "rating": 51
    },
    {
      "id": "ronnie-peterson",
      "name": "Ronnie Peterson",
      "firstYear": 1970,
      "lastYear": 1978,
      "seasons": 9,
      "rating": 74
    },
    {
      "id": "rubens-barrichello",
      "name": "Rubens Barrichello",
      "firstYear": 1993,
      "lastYear": 2011,
      "seasons": 19,
      "rating": 87
    },
    {
      "id": "sam-tingle",
      "name": "Sam Tingle",
      "firstYear": 1962,
      "lastYear": 1969,
      "seasons": 6,
      "rating": 48
    },
    {
      "id": "satoru-nakajima",
      "name": "Satoru Nakajima",
      "firstYear": 1987,
      "lastYear": 1991,
      "seasons": 5,
      "rating": 58
    },
    {
      "id": "sebastian-vettel",
      "name": "Sebastian Vettel",
      "firstYear": 2007,
      "lastYear": 2022,
      "seasons": 16,
      "rating": 99
    },
    {
      "id": "sergio-perez",
      "name": "Sergio Pérez",
      "firstYear": 2011,
      "lastYear": 2024,
      "seasons": 14,
      "rating": 79
    },
    {
      "id": "shinji-nakano",
      "name": "Shinji Nakano",
      "firstYear": 1997,
      "lastYear": 1998,
      "seasons": 2,
      "rating": 46
    },
    {
      "id": "shorty-templeman",
      "name": "Shorty Templeman",
      "firstYear": 1955,
      "lastYear": 1960,
      "seasons": 3,
      "rating": 51
    },
    {
      "id": "stefan-johansson",
      "name": "Stefan Johansson",
      "firstYear": 1980,
      "lastYear": 1991,
      "seasons": 10,
      "rating": 67
    },
    {
      "id": "stefano-modena",
      "name": "Stefano Modena",
      "firstYear": 1987,
      "lastYear": 1992,
      "seasons": 6,
      "rating": 64
    },
    {
      "id": "stirling-moss",
      "name": "Stirling Moss",
      "firstYear": 1951,
      "lastYear": 1961,
      "seasons": 11,
      "rating": 76
    },
    {
      "id": "stoffel-vandoorne",
      "name": "Stoffel Vandoorne",
      "firstYear": 2016,
      "lastYear": 2018,
      "seasons": 3,
      "rating": 46
    },
    {
      "id": "sebastien-bourdais",
      "name": "Sébastien Bourdais",
      "firstYear": 2008,
      "lastYear": 2009,
      "seasons": 2,
      "rating": 49
    },
    {
      "id": "takuma-sato",
      "name": "Takuma Sato",
      "firstYear": 2002,
      "lastYear": 2008,
      "seasons": 7,
      "rating": 63
    },
    {
      "id": "ted-whiteaway",
      "name": "Ted Whiteaway",
      "firstYear": 1955,
      "lastYear": 1955,
      "seasons": 1,
      "rating": 54
    },
    {
      "id": "thierry-boutsen",
      "name": "Thierry Boutsen",
      "firstYear": 1983,
      "lastYear": 1993,
      "seasons": 11,
      "rating": 71
    },
    {
      "id": "timo-glock",
      "name": "Timo Glock",
      "firstYear": 2004,
      "lastYear": 2012,
      "seasons": 6,
      "rating": 52
    },
    {
      "id": "tom-pryce",
      "name": "Tom Pryce",
      "firstYear": 1974,
      "lastYear": 1977,
      "seasons": 4,
      "rating": 62
    },
    {
      "id": "tony-trimmer",
      "name": "Tony Trimmer",
      "firstYear": 1975,
      "lastYear": 1978,
      "seasons": 4,
      "rating": 61
    },
    {
      "id": "toranosuke-takagi",
      "name": "Toranosuke Takagi",
      "firstYear": 1998,
      "lastYear": 1999,
      "seasons": 2,
      "rating": 54
    },
    {
      "id": "trevor-blokdyk",
      "name": "Trevor Blokdyk",
      "firstYear": 1963,
      "lastYear": 1965,
      "seasons": 2,
      "rating": 53
    },
    {
      "id": "valtteri-bottas",
      "name": "Valtteri Bottas",
      "firstYear": 2013,
      "lastYear": 2024,
      "seasons": 12,
      "rating": 86
    },
    {
      "id": "vittorio-brambilla",
      "name": "Vittorio Brambilla",
      "firstYear": 1974,
      "lastYear": 1980,
      "seasons": 7,
      "rating": 54
    },
    {
      "id": "yannick-dalmas",
      "name": "Yannick Dalmas",
      "firstYear": 1987,
      "lastYear": 1994,
      "seasons": 5,
      "rating": 58
    },
    {
      "id": "yuki-tsunoda",
      "name": "Yuki Tsunoda",
      "firstYear": 2021,
      "lastYear": 2024,
      "seasons": 4,
      "rating": 61
    }
  ],
  "recordBook": {
    "titles": [
      {
        "name": "Lewis Hamilton",
        "value": 7
      },
      {
        "name": "Michael Schumacher",
        "value": 7
      },
      {
        "name": "Juan Fangio",
        "value": 5
      },
      {
        "name": "Alain Prost",
        "value": 4
      },
      {
        "name": "Max Verstappen",
        "value": 4
      },
      {
        "name": "Sebastian Vettel",
        "value": 4
      },
      {
        "name": "Ayrton Senna",
        "value": 3
      },
      {
        "name": "Jack Brabham",
        "value": 3
      },
      {
        "name": "Jackie Stewart",
        "value": 3
      },
      {
        "name": "Nelson Piquet",
        "value": 3
      },
      {
        "name": "Niki Lauda",
        "value": 3
      },
      {
        "name": "Alberto Ascari",
        "value": 2
      },
      {
        "name": "Emerson Fittipaldi",
        "value": 2
      },
      {
        "name": "Fernando Alonso",
        "value": 2
      },
      {
        "name": "Graham Hill",
        "value": 2
      },
      {
        "name": "Jim Clark",
        "value": 2
      },
      {
        "name": "Mika Häkkinen",
        "value": 2
      },
      {
        "name": "Alan Jones",
        "value": 1
      },
      {
        "name": "Damon Hill",
        "value": 1
      },
      {
        "name": "Denny Hulme",
        "value": 1
      },
      {
        "name": "Jacques Villeneuve",
        "value": 1
      },
      {
        "name": "James Hunt",
        "value": 1
      },
      {
        "name": "Jenson Button",
        "value": 1
      },
      {
        "name": "Jochen Rindt",
        "value": 1
      },
      {
        "name": "Jody Scheckter",
        "value": 1
      }
    ],
    "wins": [
      {
        "name": "Lewis Hamilton",
        "value": 105
      },
      {
        "name": "Michael Schumacher",
        "value": 91
      },
      {
        "name": "Max Verstappen",
        "value": 63
      },
      {
        "name": "Sebastian Vettel",
        "value": 53
      },
      {
        "name": "Alain Prost",
        "value": 51
      },
      {
        "name": "Ayrton Senna",
        "value": 41
      },
      {
        "name": "Fernando Alonso",
        "value": 32
      },
      {
        "name": "Nigel Mansell",
        "value": 31
      },
      {
        "name": "Jackie Stewart",
        "value": 27
      },
      {
        "name": "Jim Clark",
        "value": 25
      },
      {
        "name": "Niki Lauda",
        "value": 25
      },
      {
        "name": "Juan Fangio",
        "value": 24
      },
      {
        "name": "Nelson Piquet",
        "value": 23
      },
      {
        "name": "Nico Rosberg",
        "value": 23
      },
      {
        "name": "Damon Hill",
        "value": 22
      },
      {
        "name": "Kimi Räikkönen",
        "value": 21
      },
      {
        "name": "Mika Häkkinen",
        "value": 20
      },
      {
        "name": "Stirling Moss",
        "value": 16
      },
      {
        "name": "Jenson Button",
        "value": 15
      },
      {
        "name": "Emerson Fittipaldi",
        "value": 14
      },
      {
        "name": "Graham Hill",
        "value": 14
      },
      {
        "name": "Jack Brabham",
        "value": 14
      },
      {
        "name": "Alberto Ascari",
        "value": 13
      },
      {
        "name": "David Coulthard",
        "value": 13
      },
      {
        "name": "Alan Jones",
        "value": 12
      }
    ],
    "podiums": [
      {
        "name": "Lewis Hamilton",
        "value": 202
      },
      {
        "name": "Michael Schumacher",
        "value": 155
      },
      {
        "name": "Sebastian Vettel",
        "value": 122
      },
      {
        "name": "Max Verstappen",
        "value": 112
      },
      {
        "name": "Alain Prost",
        "value": 106
      },
      {
        "name": "Fernando Alonso",
        "value": 106
      },
      {
        "name": "Kimi Räikkönen",
        "value": 103
      },
      {
        "name": "Ayrton Senna",
        "value": 80
      },
      {
        "name": "Rubens Barrichello",
        "value": 68
      },
      {
        "name": "Valtteri Bottas",
        "value": 67
      },
      {
        "name": "David Coulthard",
        "value": 62
      },
      {
        "name": "Nelson Piquet",
        "value": 60
      },
      {
        "name": "Nigel Mansell",
        "value": 59
      },
      {
        "name": "Nico Rosberg",
        "value": 57
      },
      {
        "name": "Niki Lauda",
        "value": 54
      },
      {
        "name": "Mika Häkkinen",
        "value": 51
      },
      {
        "name": "Jenson Button",
        "value": 50
      },
      {
        "name": "Gerhard Berger",
        "value": 48
      },
      {
        "name": "Carlos Reutemann",
        "value": 45
      },
      {
        "name": "Charles Leclerc",
        "value": 43
      },
      {
        "name": "Jackie Stewart",
        "value": 43
      },
      {
        "name": "Damon Hill",
        "value": 42
      },
      {
        "name": "Mark Webber",
        "value": 42
      },
      {
        "name": "Felipe Massa",
        "value": 41
      },
      {
        "name": "Sergio Pérez",
        "value": 39
      }
    ],
    "seasons": [
      {
        "name": "Fernando Alonso",
        "value": 21
      },
      {
        "name": "Kimi Räikkönen",
        "value": 19
      },
      {
        "name": "Michael Schumacher",
        "value": 19
      },
      {
        "name": "Rubens Barrichello",
        "value": 19
      },
      {
        "name": "Graham Hill",
        "value": 18
      },
      {
        "name": "Jenson Button",
        "value": 18
      },
      {
        "name": "Lewis Hamilton",
        "value": 18
      },
      {
        "name": "Riccardo Patrese",
        "value": 17
      },
      {
        "name": "Jack Brabham",
        "value": 16
      },
      {
        "name": "Jo Bonnier",
        "value": 16
      },
      {
        "name": "Sebastian Vettel",
        "value": 16
      },
      {
        "name": "Andrea de Cesaris",
        "value": 15
      },
      {
        "name": "David Coulthard",
        "value": 15
      },
      {
        "name": "Felipe Massa",
        "value": 15
      },
      {
        "name": "Jarno Trulli",
        "value": 15
      },
      {
        "name": "Maurice Trintignant",
        "value": 15
      },
      {
        "name": "Nigel Mansell",
        "value": 15
      },
      {
        "name": "Chris Amon",
        "value": 14
      },
      {
        "name": "Daniel Ricciardo",
        "value": 14
      },
      {
        "name": "Gerhard Berger",
        "value": 14
      },
      {
        "name": "Giancarlo Fisichella",
        "value": 14
      },
      {
        "name": "Mario Andretti",
        "value": 14
      },
      {
        "name": "Michele Alboreto",
        "value": 14
      },
      {
        "name": "Nelson Piquet",
        "value": 14
      },
      {
        "name": "Sergio Pérez",
        "value": 14
      }
    ]
  }
};

export default fallbackBootstrap;
